// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { EntityDetail_EntityFragment } from '../../graphql/EntityDetailPage.generated';
import { ClientProfileSummaryPanel_ClientProfileFragment } from '../../../../summaryPanels/ClientProfileSummaryPanel/graphql/ClientProfileSummaryPanel.generated';
import { HypotheticalTransfersSummary_EntityFragment, HypotheticalTransfersSummary_ClientProfileFragment } from '../../../../summaryPanels/HypotheticalTransfersSummaryPanel/graphql/HypotheticalTransfersSummary.generated';
import { gql } from '@apollo/client';
import { EntityDetail_EntityFragmentDoc } from '../../graphql/EntityDetailPage.generated';
import { ClientProfileSummaryPanel_ClientProfileFragmentDoc } from '../../../../summaryPanels/ClientProfileSummaryPanel/graphql/ClientProfileSummaryPanel.generated';
import { HypotheticalTransfersSummary_EntityFragmentDoc, HypotheticalTransfersSummary_ClientProfileFragmentDoc } from '../../../../summaryPanels/HypotheticalTransfersSummaryPanel/graphql/HypotheticalTransfersSummary.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHypotheticalTransfers_HypotheticalTransferFragment = { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string, sourceKind: Types.EstateWaterfallHypotheticalTransferSourceKind, destinationKind: Types.EstateWaterfallHypotheticalTransferDestinationKind, transferOrder: number, transferTaxKind: Types.EstateWaterfallHypotheticalTransferTransferTaxKind, transferValue?: CurrencyUSD | null, taxableValue?: CurrencyUSD | null, startYear?: number | null, endYear?: number | null, name?: string | null, assetGrowthReturn?: Percent | null, destinationEntity?: { __typename?: 'Entity', id: string, extendedDisplayKind: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, destinationIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, destinationOrganization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, sourceEntity?: (
    { __typename?: 'Entity', id: string }
    & EntityDetail_EntityFragment
  ) | null, sourceIndividual?: (
    { __typename?: 'ClientProfile', id: string }
    & ClientProfileSummaryPanel_ClientProfileFragment
  ) | null, sourceOwnedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null };

export type GetHypotheticalTransfers_HypotheticalSaleLoanFragment = { __typename?: 'HypotheticalSaleLoan', id: string, displayName: string, startDate: Time, termLengthYears: number, kind: Types.HypotheticalSaleLoanKind, sourceKind: Types.HypotheticalSaleLoanSourceKind, recipientKind: Types.HypotheticalSaleLoanRecipientKind, sourceEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null, sourceIndividual?: (
    { __typename?: 'ClientProfile' }
    & HypotheticalTransfersSummary_ClientProfileFragment
  ) | null, recipientEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null, recipientIndividual?: (
    { __typename?: 'ClientProfile' }
    & HypotheticalTransfersSummary_ClientProfileFragment
  ) | null };

export type GetHypotheticalTransfers_HypotheticalGratFragment = { __typename?: 'HypotheticalGRAT', id: string, displayName: string, funding?: { __typename?: 'HypotheticalTransferFundingSource', id: string, kind: Types.HypotheticalTransferFundingSourceKind, proRataAmount?: CurrencyUSD | null } | null, simulatedGrat: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }, sourceEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null };

export type GetHypotheticalTransfers_HypotheticalCrtFragment = { __typename?: 'HypotheticalCRT', id: string, displayName: string, funding?: { __typename?: 'HypotheticalTransferFundingSource', id: string, kind: Types.HypotheticalTransferFundingSourceKind, proRataAmount?: CurrencyUSD | null } | null, simulatedCrt: { __typename?: 'Proposal', id: string, displayName: string, crtProposal?: { __typename?: 'CRTProposal', id: string, termKind: Types.CharitableTrustTermKind } | null }, sourceEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null };

export type GetHypotheticalTransfers_HypotheticalCltFragment = { __typename?: 'HypotheticalCLT', id: string, displayName: string, funding?: { __typename?: 'HypotheticalTransferFundingSource', id: string, kind: Types.HypotheticalTransferFundingSourceKind, proRataAmount?: CurrencyUSD | null } | null, simulatedClt: { __typename?: 'Proposal', id: string, displayName: string, cltProposal?: { __typename?: 'CLTProposal', id: string, termKind: Types.CharitableTrustTermKind } | null }, sourceEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null };

export type GetHypotheticalTransfers_HypotheticalInsuranceFragment = { __typename?: 'HypotheticalInsurance', id: string, displayName: string, startYear?: number | null, endYear?: number | null, transferValue: CurrencyUSD, sourceKind: Types.HypotheticalInsuranceSourceKind, endsOnKind: Types.HypotheticalInsuranceEndsOnKind, sourceIndividual?: (
    { __typename?: 'ClientProfile' }
    & HypotheticalTransfersSummary_ClientProfileFragment
  ) | null, sourceEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null, destinationEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransfersSummary_EntityFragment
  ) | null };

export type GetHypotheticalTransfers_EstateWaterfallLoanFragment = { __typename?: 'EstateWaterfallLoan', id?: string | null, pseudoID?: string | null, valueHistory: Array<{ __typename?: 'EstateWaterfallLoanValueHistory', year: number, beginningOfYearValue?: CurrencyUSD | null, interestPaid?: CurrencyUSD | null, principalPaid?: CurrencyUSD | null }> };

export type GetHypotheticalTransfers_EstateWaterfallNodeValueHistoryFragment = { __typename?: 'EstateWaterfallNodeValueHistory', year: number, endOfYearValue?: CurrencyUSD | null, beginningOfYearValue?: CurrencyUSD | null };

export type GetHypotheticalTransfers_EstateWaterfallVizNodeFragment = { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string, valueHistory: Array<(
    { __typename?: 'EstateWaterfallNodeValueHistory' }
    & GetHypotheticalTransfers_EstateWaterfallNodeValueHistoryFragment
  )> };

export type GetHypotheticalTransfers_EstateWaterfallVizEdgeFragment = { __typename?: 'EstateWaterfallVizEdge', to: { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string }, from: { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string }, associatedTransfers?: Array<{ __typename?: 'EstateWaterfallVizEdgeAssociatedTransfer', value: CurrencyUSD, transfer: { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string } } | null> | null };

export type TransferNode_Node_AiSuggestion_Fragment = { __typename?: 'AISuggestion', id: string };

export type TransferNode_Node_AiSuggestionEvidence_Fragment = { __typename?: 'AISuggestionEvidence', id: string };

export type TransferNode_Node_AccessAgeParameter_Fragment = { __typename?: 'AccessAgeParameter', id: string };

export type TransferNode_Node_AccessParameter_Fragment = { __typename?: 'AccessParameter', id: string };

export type TransferNode_Node_Account_Fragment = { __typename?: 'Account', id: string };

export type TransferNode_Node_ActiveEstateInsightsPage_Fragment = { __typename?: 'ActiveEstateInsightsPage', id: string };

export type TransferNode_Node_Activity_Fragment = { __typename?: 'Activity', id: string };

export type TransferNode_Node_Address_Fragment = { __typename?: 'Address', id: string };

export type TransferNode_Node_Answer_Fragment = { __typename?: 'Answer', id: string };

export type TransferNode_Node_AnswerEvidence_Fragment = { __typename?: 'AnswerEvidence', id: string };

export type TransferNode_Node_AnswerRevision_Fragment = { __typename?: 'AnswerRevision', id: string };

export type TransferNode_Node_Approval_Fragment = { __typename?: 'Approval', id: string };

export type TransferNode_Node_AssetClass_Fragment = { __typename?: 'AssetClass', id: string };

export type TransferNode_Node_AssetGroup_Fragment = { __typename?: 'AssetGroup', id: string };

export type TransferNode_Node_AssetStatic_Fragment = { __typename?: 'AssetStatic', id: string };

export type TransferNode_Node_AssetV2_Fragment = { __typename?: 'AssetV2', id: string };

export type TransferNode_Node_AssetValuationV2_Fragment = { __typename?: 'AssetValuationV2', id: string };

export type TransferNode_Node_AssetValueV2_Fragment = { __typename?: 'AssetValueV2', id: string };

export type TransferNode_Node_AsyncJob_Fragment = { __typename?: 'AsyncJob', id: string };

export type TransferNode_Node_BalanceSheetBundleConfiguration_Fragment = { __typename?: 'BalanceSheetBundleConfiguration', id: string };

export type TransferNode_Node_BalanceSheetCategory_Fragment = { __typename?: 'BalanceSheetCategory', id: string };

export type TransferNode_Node_BalanceSheetViewConfiguration_Fragment = { __typename?: 'BalanceSheetViewConfiguration', id: string };

export type TransferNode_Node_BeneficiariesBundleConfiguration_Fragment = { __typename?: 'BeneficiariesBundleConfiguration', id: string };

export type TransferNode_Node_BeneficiariesTemplateBundleConfiguration_Fragment = { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string };

export type TransferNode_Node_Beneficiary_Fragment = { __typename?: 'Beneficiary', id: string };

export type TransferNode_Node_BeneficiaryAccessParameter_Fragment = { __typename?: 'BeneficiaryAccessParameter', id: string };

export type TransferNode_Node_BeneficiaryDesignationGroup_Fragment = { __typename?: 'BeneficiaryDesignationGroup', id: string };

export type TransferNode_Node_BeneficiaryDistribution_Fragment = { __typename?: 'BeneficiaryDistribution', id: string };

export type TransferNode_Node_BeneficiaryDistributionParameter_Fragment = { __typename?: 'BeneficiaryDistributionParameter', id: string };

export type TransferNode_Node_BeneficiaryPage_Fragment = { __typename?: 'BeneficiaryPage', id: string };

export type TransferNode_Node_BeneficiaryPowerOfAppointment_Fragment = { __typename?: 'BeneficiaryPowerOfAppointment', id: string };

export type TransferNode_Node_CCorpBusinessEntity_Fragment = { __typename?: 'CCorpBusinessEntity', id: string };

export type TransferNode_Node_CltProposal_Fragment = { __typename?: 'CLTProposal', id: string };

export type TransferNode_Node_CltTrust_Fragment = { __typename?: 'CLTTrust', id: string };

export type TransferNode_Node_CrtProposal_Fragment = { __typename?: 'CRTProposal', id: string };

export type TransferNode_Node_CrtTrust_Fragment = { __typename?: 'CRTTrust', id: string };

export type TransferNode_Node_Capability_Fragment = { __typename?: 'Capability', id: string };

export type TransferNode_Node_Cashflow_Fragment = { __typename?: 'Cashflow', id: string };

export type TransferNode_Node_ClientOrganization_Fragment = { __typename?: 'ClientOrganization', id: string, name: string };

export type TransferNode_Node_ClientPresentationV2_Fragment = { __typename?: 'ClientPresentationV2', id: string };

export type TransferNode_Node_ClientProfile_Fragment = { __typename?: 'ClientProfile', id: string, displayName: string };

export type TransferNode_Node_ClientProfileRelationship_Fragment = { __typename?: 'ClientProfileRelationship', id: string };

export type TransferNode_Node_Collaborator_Fragment = { __typename?: 'Collaborator', id: string };

export type TransferNode_Node_ComparedWaterfall_Fragment = { __typename?: 'ComparedWaterfall', id: string };

export type TransferNode_Node_CompletedEstateInsightsPage_Fragment = { __typename?: 'CompletedEstateInsightsPage', id: string };

export type TransferNode_Node_ControllingParty_Fragment = { __typename?: 'ControllingParty', id: string };

export type TransferNode_Node_Conversation_Fragment = { __typename?: 'Conversation', id: string };

export type TransferNode_Node_CoverPageConfiguration_Fragment = { __typename?: 'CoverPageConfiguration', id: string };

export type TransferNode_Node_CustodialPersonalAccount_Fragment = { __typename?: 'CustodialPersonalAccount', id: string };

export type TransferNode_Node_DsuePortability_Fragment = { __typename?: 'DSUEPortability', id: string };

export type TransferNode_Node_DiagramArtifact_Fragment = { __typename?: 'DiagramArtifact', id: string };

export type TransferNode_Node_DiagramArtifactPrompt_Fragment = { __typename?: 'DiagramArtifactPrompt', id: string };

export type TransferNode_Node_DispositionScenario_Fragment = { __typename?: 'DispositionScenario', id: string };

export type TransferNode_Node_DispositiveProvision_Fragment = { __typename?: 'DispositiveProvision', id: string };

export type TransferNode_Node_DispositiveProvisionTemplate_Fragment = { __typename?: 'DispositiveProvisionTemplate', id: string };

export type TransferNode_Node_DividerBundleConfiguration_Fragment = { __typename?: 'DividerBundleConfiguration', id: string };

export type TransferNode_Node_DividerTemplateBundleConfiguration_Fragment = { __typename?: 'DividerTemplateBundleConfiguration', id: string };

export type TransferNode_Node_Document_Fragment = { __typename?: 'Document', id: string };

export type TransferNode_Node_DocumentQuestion_Fragment = { __typename?: 'DocumentQuestion', id: string };

export type TransferNode_Node_DocumentQuestionAnswers_Fragment = { __typename?: 'DocumentQuestionAnswers', id: string };

export type TransferNode_Node_DocumentSummary_Fragment = { __typename?: 'DocumentSummary', id: string };

export type TransferNode_Node_DocumentSummaryPage_Fragment = { __typename?: 'DocumentSummaryPage', id: string };

export type TransferNode_Node_DocumentSummaryPrompt_Fragment = { __typename?: 'DocumentSummaryPrompt', id: string };

export type TransferNode_Node_DocumentSummaryPromptTestRun_Fragment = { __typename?: 'DocumentSummaryPromptTestRun', id: string };

export type TransferNode_Node_DocumentSummaryTemplateBundleConfiguration_Fragment = { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string };

export type TransferNode_Node_DonorAdvisedFund_Fragment = { __typename?: 'DonorAdvisedFund', id: string };

export type TransferNode_Node_Employee_Fragment = { __typename?: 'Employee', id: string };

export type TransferNode_Node_EntitiesOverviewBundleConfiguration_Fragment = { __typename?: 'EntitiesOverviewBundleConfiguration', id: string };

export type TransferNode_Node_EntitiesOverviewBundleConfigurationEntity_Fragment = { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string };

export type TransferNode_Node_Entity_Fragment = { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type TransferNode_Node_EntityDiagram_Fragment = { __typename?: 'EntityDiagram', id: string };

export type TransferNode_Node_EntityDocumentRelationship_Fragment = { __typename?: 'EntityDocumentRelationship', id: string };

export type TransferNode_Node_EntityGraphView_Fragment = { __typename?: 'EntityGraphView', id: string };

export type TransferNode_Node_EntityGraphViewBundleConfiguration_Fragment = { __typename?: 'EntityGraphViewBundleConfiguration', id: string };

export type TransferNode_Node_EntityNotes_Fragment = { __typename?: 'EntityNotes', id: string };

export type TransferNode_Node_EntityProposal_Fragment = { __typename?: 'EntityProposal', id: string };

export type TransferNode_Node_EntitySummaryBundleConfiguration_Fragment = { __typename?: 'EntitySummaryBundleConfiguration', id: string };

export type TransferNode_Node_EntitySummaryTemplateBundleConfiguration_Fragment = { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string };

export type TransferNode_Node_EntityTask_Fragment = { __typename?: 'EntityTask', id: string };

export type TransferNode_Node_EntityTaxInfo_Fragment = { __typename?: 'EntityTaxInfo', id: string };

export type TransferNode_Node_EstateInsight_Fragment = { __typename?: 'EstateInsight', id: string };

export type TransferNode_Node_EstateInsightReference_Fragment = { __typename?: 'EstateInsightReference', id: string };

export type TransferNode_Node_EstateInsightsBundleConfiguration_Fragment = { __typename?: 'EstateInsightsBundleConfiguration', id: string };

export type TransferNode_Node_EstateTaxScenario_Fragment = { __typename?: 'EstateTaxScenario', id: string };

export type TransferNode_Node_EstateWaterfall_Fragment = { __typename?: 'EstateWaterfall', id: string };

export type TransferNode_Node_EstateWaterfallHypotheticalStateChange_Fragment = { __typename?: 'EstateWaterfallHypotheticalStateChange', id: string };

export type TransferNode_Node_EstateWaterfallHypotheticalTransfer_Fragment = { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string };

export type TransferNode_Node_EstateWaterfallMessageContext_Fragment = { __typename?: 'EstateWaterfallMessageContext', id: string };

export type TransferNode_Node_EstateWaterfallVisualizationConfig_Fragment = { __typename?: 'EstateWaterfallVisualizationConfig', id: string };

export type TransferNode_Node_EstateWaterfallVisualizationFilter_Fragment = { __typename?: 'EstateWaterfallVisualizationFilter', id: string };

export type TransferNode_Node_FamilyTreeBundleConfiguration_Fragment = { __typename?: 'FamilyTreeBundleConfiguration', id: string };

export type TransferNode_Node_FamilyTreeConfiguration_Fragment = { __typename?: 'FamilyTreeConfiguration', id: string };

export type TransferNode_Node_FeatureFlag_Fragment = { __typename?: 'FeatureFlag', id: string };

export type TransferNode_Node_FeatureFlagQueryRule_Fragment = { __typename?: 'FeatureFlagQueryRule', id: string };

export type TransferNode_Node_File_Fragment = { __typename?: 'File', id: string };

export type TransferNode_Node_FilePage_Fragment = { __typename?: 'FilePage', id: string };

export type TransferNode_Node_FileParagraph_Fragment = { __typename?: 'FileParagraph', id: string };

export type TransferNode_Node_Form_Fragment = { __typename?: 'Form', id: string };

export type TransferNode_Node_FormVersion_Fragment = { __typename?: 'FormVersion', id: string };

export type TransferNode_Node_GpBusinessEntity_Fragment = { __typename?: 'GPBusinessEntity', id: string };

export type TransferNode_Node_GratAnnuityV2_Fragment = { __typename?: 'GRATAnnuityV2', id: string };

export type TransferNode_Node_GratProposalScenario_Fragment = { __typename?: 'GRATProposalScenario', id: string };

export type TransferNode_Node_GratTrust_Fragment = { __typename?: 'GRATTrust', id: string };

export type TransferNode_Node_GiftingProposal_Fragment = { __typename?: 'GiftingProposal', id: string };

export type TransferNode_Node_GiftingProposalCashFlow_Fragment = { __typename?: 'GiftingProposalCashFlow', id: string };

export type TransferNode_Node_GiftingProposalGift_Fragment = { __typename?: 'GiftingProposalGift', id: string };

export type TransferNode_Node_GiftingProposalGiftSender_Fragment = { __typename?: 'GiftingProposalGiftSender', id: string };

export type TransferNode_Node_GiftingProposalPortfolio_Fragment = { __typename?: 'GiftingProposalPortfolio', id: string };

export type TransferNode_Node_GiftingProposalScenario_Fragment = { __typename?: 'GiftingProposalScenario', id: string };

export type TransferNode_Node_GraphVisualizationGroup_Fragment = { __typename?: 'GraphVisualizationGroup', id: string };

export type TransferNode_Node_GrowthProfile_Fragment = { __typename?: 'GrowthProfile', id: string };

export type TransferNode_Node_GrowthProfileOverride_Fragment = { __typename?: 'GrowthProfileOverride', id: string };

export type TransferNode_Node_Household_Fragment = { __typename?: 'Household', id: string };

export type TransferNode_Node_HypotheticalClt_Fragment = { __typename?: 'HypotheticalCLT', id: string };

export type TransferNode_Node_HypotheticalCrt_Fragment = { __typename?: 'HypotheticalCRT', id: string };

export type TransferNode_Node_HypotheticalGrat_Fragment = { __typename?: 'HypotheticalGRAT', id: string };

export type TransferNode_Node_HypotheticalInsurance_Fragment = { __typename?: 'HypotheticalInsurance', id: string };

export type TransferNode_Node_HypotheticalSaleLoan_Fragment = { __typename?: 'HypotheticalSaleLoan', id: string };

export type TransferNode_Node_HypotheticalTransferAsset_Fragment = { __typename?: 'HypotheticalTransferAsset', id: string };

export type TransferNode_Node_HypotheticalTransferFundingSource_Fragment = { __typename?: 'HypotheticalTransferFundingSource', id: string };

export type TransferNode_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment = { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string };

export type TransferNode_Node_IlitCrummeyLetter_Fragment = { __typename?: 'ILITCrummeyLetter', id: string };

export type TransferNode_Node_IlitTrust_Fragment = { __typename?: 'ILITTrust', id: string };

export type TransferNode_Node_Image_Fragment = { __typename?: 'Image', id: string };

export type TransferNode_Node_IncomeTaxPaymentConfig_Fragment = { __typename?: 'IncomeTaxPaymentConfig', id: string };

export type TransferNode_Node_IndividualPersonalAccount_Fragment = { __typename?: 'IndividualPersonalAccount', id: string };

export type TransferNode_Node_InferredField_Fragment = { __typename?: 'InferredField', id: string };

export type TransferNode_Node_InferredFieldEvidence_Fragment = { __typename?: 'InferredFieldEvidence', id: string };

export type TransferNode_Node_InsightsTemplateBundleConfiguration_Fragment = { __typename?: 'InsightsTemplateBundleConfiguration', id: string };

export type TransferNode_Node_InsurancePersonalAccount_Fragment = { __typename?: 'InsurancePersonalAccount', id: string };

export type TransferNode_Node_InsurancePolicy_Fragment = { __typename?: 'InsurancePolicy', id: string };

export type TransferNode_Node_InsurancePremiumPayment_Fragment = { __typename?: 'InsurancePremiumPayment', id: string };

export type TransferNode_Node_IntegrationAssetClass_Fragment = { __typename?: 'IntegrationAssetClass', id: string };

export type TransferNode_Node_IntegrationCashflow_Fragment = { __typename?: 'IntegrationCashflow', id: string };

export type TransferNode_Node_IntegrationClient_Fragment = { __typename?: 'IntegrationClient', id: string };

export type TransferNode_Node_IntegrationConfiguration_Fragment = { __typename?: 'IntegrationConfiguration', id: string };

export type TransferNode_Node_IntegrationEntity_Fragment = { __typename?: 'IntegrationEntity', id: string };

export type TransferNode_Node_IntegrationInsurance_Fragment = { __typename?: 'IntegrationInsurance', id: string };

export type TransferNode_Node_IntegrationLiability_Fragment = { __typename?: 'IntegrationLiability', id: string };

export type TransferNode_Node_IntegrationPerson_Fragment = { __typename?: 'IntegrationPerson', id: string };

export type TransferNode_Node_IrrevocableTrust_Fragment = { __typename?: 'IrrevocableTrust', id: string };

export type TransferNode_Node_JointPersonalAccount_Fragment = { __typename?: 'JointPersonalAccount', id: string };

export type TransferNode_Node_KgNode_Fragment = { __typename?: 'KGNode', id: string };

export type TransferNode_Node_KgRelationship_Fragment = { __typename?: 'KGRelationship', id: string };

export type TransferNode_Node_KgRoot_Fragment = { __typename?: 'KGRoot', id: string };

export type TransferNode_Node_Kgv2Document_Fragment = { __typename?: 'KGV2Document', id: string };

export type TransferNode_Node_Kgv2DocumentChange_Fragment = { __typename?: 'KGV2DocumentChange', id: string };

export type TransferNode_Node_Kgv2DocumentModification_Fragment = { __typename?: 'KGV2DocumentModification', id: string };

export type TransferNode_Node_Kgv2Graph_Fragment = { __typename?: 'KGV2Graph', id: string };

export type TransferNode_Node_Kgv2Node_Fragment = { __typename?: 'KGV2Node', id: string };

export type TransferNode_Node_Kgv2NodeAlias_Fragment = { __typename?: 'KGV2NodeAlias', id: string };

export type TransferNode_Node_Kgv2NodeEvidence_Fragment = { __typename?: 'KGV2NodeEvidence', id: string };

export type TransferNode_Node_Kgv2Statement_Fragment = { __typename?: 'KGV2Statement', id: string };

export type TransferNode_Node_Kgv2StatementEvidence_Fragment = { __typename?: 'KGV2StatementEvidence', id: string };

export type TransferNode_Node_Kgv2StatementSupersession_Fragment = { __typename?: 'KGV2StatementSupersession', id: string };

export type TransferNode_Node_KeyPerson_Fragment = { __typename?: 'KeyPerson', id: string };

export type TransferNode_Node_KeyPersonRole_Fragment = { __typename?: 'KeyPersonRole', id: string };

export type TransferNode_Node_LlcBusinessEntity_Fragment = { __typename?: 'LLCBusinessEntity', id: string };

export type TransferNode_Node_LpBusinessEntity_Fragment = { __typename?: 'LPBusinessEntity', id: string };

export type TransferNode_Node_LiabilitiesBundleConfiguration_Fragment = { __typename?: 'LiabilitiesBundleConfiguration', id: string };

export type TransferNode_Node_Liability_Fragment = { __typename?: 'Liability', id: string };

export type TransferNode_Node_LiabilityPayment_Fragment = { __typename?: 'LiabilityPayment', id: string };

export type TransferNode_Node_LifeInsuranceBundleConfiguration_Fragment = { __typename?: 'LifeInsuranceBundleConfiguration', id: string };

export type TransferNode_Node_LifetimeExclusionEvent_Fragment = { __typename?: 'LifetimeExclusionEvent', id: string };

export type TransferNode_Node_LoggedTransfer_Fragment = { __typename?: 'LoggedTransfer', id: string };

export type TransferNode_Node_LuminaryOrganization_Fragment = { __typename?: 'LuminaryOrganization', id: string };

export type TransferNode_Node_LuminaryTenantJit_Fragment = { __typename?: 'LuminaryTenantJIT', id: string };

export type TransferNode_Node_ManagedSftpConnection_Fragment = { __typename?: 'ManagedSFTPConnection', id: string };

export type TransferNode_Node_Memo_Fragment = { __typename?: 'Memo', id: string };

export type TransferNode_Node_MemoPrompt_Fragment = { __typename?: 'MemoPrompt', id: string };

export type TransferNode_Node_Message_Fragment = { __typename?: 'Message', id: string };

export type TransferNode_Node_MissingDocumentOverride_Fragment = { __typename?: 'MissingDocumentOverride', id: string };

export type TransferNode_Node_MissingDocumentsPage_Fragment = { __typename?: 'MissingDocumentsPage', id: string };

export type TransferNode_Node_ModelMapping_Fragment = { __typename?: 'ModelMapping', id: string };

export type TransferNode_Node_NotificationApp_Fragment = { __typename?: 'NotificationApp', id: string };

export type TransferNode_Node_NotificationPreference_Fragment = { __typename?: 'NotificationPreference', id: string };

export type TransferNode_Node_OpenaiSdkConfig_Fragment = { __typename?: 'OpenaiSdkConfig', id: string };

export type TransferNode_Node_OrganizationApplicationConfiguration_Fragment = { __typename?: 'OrganizationApplicationConfiguration', id: string };

export type TransferNode_Node_OrganizationDisclaimerConfiguration_Fragment = { __typename?: 'OrganizationDisclaimerConfiguration', id: string };

export type TransferNode_Node_OwnershipStake_Fragment = { __typename?: 'OwnershipStake', id: string };

export type TransferNode_Node_PlatformDocument_Fragment = { __typename?: 'PlatformDocument', id: string };

export type TransferNode_Node_PlatformFile_Fragment = { __typename?: 'PlatformFile', id: string };

export type TransferNode_Node_PlatformFilePage_Fragment = { __typename?: 'PlatformFilePage', id: string };

export type TransferNode_Node_PlatformFileParagraph_Fragment = { __typename?: 'PlatformFileParagraph', id: string };

export type TransferNode_Node_PresentationApprovalRequest_Fragment = { __typename?: 'PresentationApprovalRequest', id: string };

export type TransferNode_Node_PresentationAssetDistributionBundleConfiguration_Fragment = { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string };

export type TransferNode_Node_PresentationAssetDistributionItemConfiguration_Fragment = { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string };

export type TransferNode_Node_PresentationAssetDistributionItemDetail_Fragment = { __typename?: 'PresentationAssetDistributionItemDetail', id: string };

export type TransferNode_Node_PresentationBundle_Fragment = { __typename?: 'PresentationBundle', id: string };

export type TransferNode_Node_PresentationBundleCoverPage_Fragment = { __typename?: 'PresentationBundleCoverPage', id: string };

export type TransferNode_Node_PresentationBusinessOverviewBundleConfiguration_Fragment = { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string };

export type TransferNode_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment = { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string };

export type TransferNode_Node_PresentationBusinessOverviewItem_Fragment = { __typename?: 'PresentationBusinessOverviewItem', id: string };

export type TransferNode_Node_PresentationCoverPage_Fragment = { __typename?: 'PresentationCoverPage', id: string };

export type TransferNode_Node_PresentationCoverSlideConfig_Fragment = { __typename?: 'PresentationCoverSlideConfig', id: string };

export type TransferNode_Node_PresentationCustomPage_Fragment = { __typename?: 'PresentationCustomPage', id: string };

export type TransferNode_Node_PresentationCustomPageBundleConfiguration_Fragment = { __typename?: 'PresentationCustomPageBundleConfiguration', id: string };

export type TransferNode_Node_PresentationDiagramPage_Fragment = { __typename?: 'PresentationDiagramPage', id: string };

export type TransferNode_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment = { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string };

export type TransferNode_Node_PresentationDocumentsReviewedDocument_Fragment = { __typename?: 'PresentationDocumentsReviewedDocument', id: string };

export type TransferNode_Node_PresentationFamilyOverviewBundleConfiguration_Fragment = { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string };

export type TransferNode_Node_PresentationFamilyOverviewMemberConfiguration_Fragment = { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string };

export type TransferNode_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment = { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string };

export type TransferNode_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment = { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string };

export type TransferNode_Node_PresentationHealthcareDirectiveItem_Fragment = { __typename?: 'PresentationHealthcareDirectiveItem', id: string };

export type TransferNode_Node_PresentationItemCitation_Fragment = { __typename?: 'PresentationItemCitation', id: string };

export type TransferNode_Node_PresentationPage_Fragment = { __typename?: 'PresentationPage', id: string };

export type TransferNode_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment = { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string };

export type TransferNode_Node_PresentationPlanningOpportunitiesItem_Fragment = { __typename?: 'PresentationPlanningOpportunitiesItem', id: string };

export type TransferNode_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment = { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string };

export type TransferNode_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment = { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string };

export type TransferNode_Node_PresentationPowerOfAttorneyItem_Fragment = { __typename?: 'PresentationPowerOfAttorneyItem', id: string };

export type TransferNode_Node_PresentationTemplate_Fragment = { __typename?: 'PresentationTemplate', id: string };

export type TransferNode_Node_PresentationTemplateBundle_Fragment = { __typename?: 'PresentationTemplateBundle', id: string };

export type TransferNode_Node_PresentationTemplateCoverPage_Fragment = { __typename?: 'PresentationTemplateCoverPage', id: string };

export type TransferNode_Node_PresentationTemplateCustomPage_Fragment = { __typename?: 'PresentationTemplateCustomPage', id: string };

export type TransferNode_Node_PresentationTemplateDiagramPage_Fragment = { __typename?: 'PresentationTemplateDiagramPage', id: string };

export type TransferNode_Node_PresentationTemplatePage_Fragment = { __typename?: 'PresentationTemplatePage', id: string };

export type TransferNode_Node_PresentationTrustOverviewBundleConfiguration_Fragment = { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string };

export type TransferNode_Node_PresentationTrustOverviewItem_Fragment = { __typename?: 'PresentationTrustOverviewItem', id: string };

export type TransferNode_Node_PresentationTrustOverviewTrustConfiguration_Fragment = { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string };

export type TransferNode_Node_PresentationWillBundleConfiguration_Fragment = { __typename?: 'PresentationWillBundleConfiguration', id: string };

export type TransferNode_Node_PresentationWillClientConfiguration_Fragment = { __typename?: 'PresentationWillClientConfiguration', id: string };

export type TransferNode_Node_PresentationWillItem_Fragment = { __typename?: 'PresentationWillItem', id: string };

export type TransferNode_Node_Principal_Fragment = { __typename?: 'Principal', id: string };

export type TransferNode_Node_PrivateFoundation_Fragment = { __typename?: 'PrivateFoundation', id: string };

export type TransferNode_Node_ProfessionalTeamRole_Fragment = { __typename?: 'ProfessionalTeamRole', id: string };

export type TransferNode_Node_Proposal_Fragment = { __typename?: 'Proposal', id: string, displayName: string, crtProposal?: { __typename?: 'CRTProposal', id: string, payoutKind: Types.CharitableTrustPayoutKind } | null, cltProposal?: { __typename?: 'CLTProposal', id: string, payoutKind: Types.CharitableTrustPayoutKind } | null };

export type TransferNode_Node_ProposalScenario_Fragment = { __typename?: 'ProposalScenario', id: string };

export type TransferNode_Node_QprtTrust_Fragment = { __typename?: 'QPRTTrust', id: string };

export type TransferNode_Node_QualifiedTuitionPersonalAccount_Fragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string };

export type TransferNode_Node_ReleaseGroup_Fragment = { __typename?: 'ReleaseGroup', id: string };

export type TransferNode_Node_ReminderEmailNotificationRecord_Fragment = { __typename?: 'ReminderEmailNotificationRecord', id: string };

export type TransferNode_Node_RetirementPersonalAccount_Fragment = { __typename?: 'RetirementPersonalAccount', id: string };

export type TransferNode_Node_RevocableTrust_Fragment = { __typename?: 'RevocableTrust', id: string };

export type TransferNode_Node_Role_Fragment = { __typename?: 'Role', id: string };

export type TransferNode_Node_SCorpBusinessEntity_Fragment = { __typename?: 'SCorpBusinessEntity', id: string };

export type TransferNode_Node_SlatTrust_Fragment = { __typename?: 'SLATTrust', id: string };

export type TransferNode_Node_SsoConnection_Fragment = { __typename?: 'SSOConnection', id: string };

export type TransferNode_Node_SalesforceExportAttempt_Fragment = { __typename?: 'SalesforceExportAttempt', id: string };

export type TransferNode_Node_ScheduledDistribution_Fragment = { __typename?: 'ScheduledDistribution', id: string };

export type TransferNode_Node_SoleProprietorshipBusinessEntity_Fragment = { __typename?: 'SoleProprietorshipBusinessEntity', id: string };

export type TransferNode_Node_SubBrand_Fragment = { __typename?: 'SubBrand', id: string };

export type TransferNode_Node_SubBrandDisclaimerConfiguration_Fragment = { __typename?: 'SubBrandDisclaimerConfiguration', id: string };

export type TransferNode_Node_Submission_Fragment = { __typename?: 'Submission', id: string };

export type TransferNode_Node_TaxDragConfig_Fragment = { __typename?: 'TaxDragConfig', id: string };

export type TransferNode_Node_TaxDragOverride_Fragment = { __typename?: 'TaxDragOverride', id: string };

export type TransferNode_Node_Team_Fragment = { __typename?: 'Team', id: string };

export type TransferNode_Node_Tenant_Fragment = { __typename?: 'Tenant', id: string };

export type TransferNode_Node_TenantApplicationConfiguration_Fragment = { __typename?: 'TenantApplicationConfiguration', id: string };

export type TransferNode_Node_TenantBranding_Fragment = { __typename?: 'TenantBranding', id: string };

export type TransferNode_Node_TenantDisclaimerConfiguration_Fragment = { __typename?: 'TenantDisclaimerConfiguration', id: string };

export type TransferNode_Node_TenantDocument_Fragment = { __typename?: 'TenantDocument', id: string };

export type TransferNode_Node_TenantReminderEmailsConfiguration_Fragment = { __typename?: 'TenantReminderEmailsConfiguration', id: string };

export type TransferNode_Node_TenantSsoConnection_Fragment = { __typename?: 'TenantSSOConnection', id: string };

export type TransferNode_Node_TenantSecurityConfiguration_Fragment = { __typename?: 'TenantSecurityConfiguration', id: string };

export type TransferNode_Node_TenantSlideConfig_Fragment = { __typename?: 'TenantSlideConfig', id: string };

export type TransferNode_Node_TestCmkEncryption_Fragment = { __typename?: 'TestCMKEncryption', id: string };

export type TransferNode_Node_TestamentaryEntity_Fragment = { __typename?: 'TestamentaryEntity', id: string };

export type TransferNode_Node_TrustAdvisor_Fragment = { __typename?: 'TrustAdvisor', id: string };

export type TransferNode_Node_TrustAdvisorRole_Fragment = { __typename?: 'TrustAdvisorRole', id: string };

export type TransferNode_Node_Trustee_Fragment = { __typename?: 'Trustee', id: string };

export type TransferNode_Node_TrusteeDuty_Fragment = { __typename?: 'TrusteeDuty', id: string };

export type TransferNode_Node_User_Fragment = { __typename?: 'User', id: string };

export type TransferNode_Node_UserFeedback_Fragment = { __typename?: 'UserFeedback', id: string };

export type TransferNode_Node_UserNotificationConfiguration_Fragment = { __typename?: 'UserNotificationConfiguration', id: string };

export type TransferNode_Node_WaterfallBundleConfiguration_Fragment = { __typename?: 'WaterfallBundleConfiguration', id: string };

export type TransferNode_Node_WaterfallBundleCoverPage_Fragment = { __typename?: 'WaterfallBundleCoverPage', id: string };

export type TransferNode_Node_WaterfallComparisonBundleConfiguration_Fragment = { __typename?: 'WaterfallComparisonBundleConfiguration', id: string };

export type TransferNode_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment = { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string };

export type TransferNode_Node_WaterfallTemplateBundleConfiguration_Fragment = { __typename?: 'WaterfallTemplateBundleConfiguration', id: string };

export type TransferNode_Node_WorkOsOrganization_Fragment = { __typename?: 'WorkOSOrganization', id: string };

export type TransferNode_Node_WorkOsOrganizationDomain_Fragment = { __typename?: 'WorkOSOrganizationDomain', id: string };

export type TransferNode_Node_WorkflowTracker_Fragment = { __typename?: 'WorkflowTracker', id: string };

export type TransferNode_NodeFragment = TransferNode_Node_AiSuggestion_Fragment | TransferNode_Node_AiSuggestionEvidence_Fragment | TransferNode_Node_AccessAgeParameter_Fragment | TransferNode_Node_AccessParameter_Fragment | TransferNode_Node_Account_Fragment | TransferNode_Node_ActiveEstateInsightsPage_Fragment | TransferNode_Node_Activity_Fragment | TransferNode_Node_Address_Fragment | TransferNode_Node_Answer_Fragment | TransferNode_Node_AnswerEvidence_Fragment | TransferNode_Node_AnswerRevision_Fragment | TransferNode_Node_Approval_Fragment | TransferNode_Node_AssetClass_Fragment | TransferNode_Node_AssetGroup_Fragment | TransferNode_Node_AssetStatic_Fragment | TransferNode_Node_AssetV2_Fragment | TransferNode_Node_AssetValuationV2_Fragment | TransferNode_Node_AssetValueV2_Fragment | TransferNode_Node_AsyncJob_Fragment | TransferNode_Node_BalanceSheetBundleConfiguration_Fragment | TransferNode_Node_BalanceSheetCategory_Fragment | TransferNode_Node_BalanceSheetViewConfiguration_Fragment | TransferNode_Node_BeneficiariesBundleConfiguration_Fragment | TransferNode_Node_BeneficiariesTemplateBundleConfiguration_Fragment | TransferNode_Node_Beneficiary_Fragment | TransferNode_Node_BeneficiaryAccessParameter_Fragment | TransferNode_Node_BeneficiaryDesignationGroup_Fragment | TransferNode_Node_BeneficiaryDistribution_Fragment | TransferNode_Node_BeneficiaryDistributionParameter_Fragment | TransferNode_Node_BeneficiaryPage_Fragment | TransferNode_Node_BeneficiaryPowerOfAppointment_Fragment | TransferNode_Node_CCorpBusinessEntity_Fragment | TransferNode_Node_CltProposal_Fragment | TransferNode_Node_CltTrust_Fragment | TransferNode_Node_CrtProposal_Fragment | TransferNode_Node_CrtTrust_Fragment | TransferNode_Node_Capability_Fragment | TransferNode_Node_Cashflow_Fragment | TransferNode_Node_ClientOrganization_Fragment | TransferNode_Node_ClientPresentationV2_Fragment | TransferNode_Node_ClientProfile_Fragment | TransferNode_Node_ClientProfileRelationship_Fragment | TransferNode_Node_Collaborator_Fragment | TransferNode_Node_ComparedWaterfall_Fragment | TransferNode_Node_CompletedEstateInsightsPage_Fragment | TransferNode_Node_ControllingParty_Fragment | TransferNode_Node_Conversation_Fragment | TransferNode_Node_CoverPageConfiguration_Fragment | TransferNode_Node_CustodialPersonalAccount_Fragment | TransferNode_Node_DsuePortability_Fragment | TransferNode_Node_DiagramArtifact_Fragment | TransferNode_Node_DiagramArtifactPrompt_Fragment | TransferNode_Node_DispositionScenario_Fragment | TransferNode_Node_DispositiveProvision_Fragment | TransferNode_Node_DispositiveProvisionTemplate_Fragment | TransferNode_Node_DividerBundleConfiguration_Fragment | TransferNode_Node_DividerTemplateBundleConfiguration_Fragment | TransferNode_Node_Document_Fragment | TransferNode_Node_DocumentQuestion_Fragment | TransferNode_Node_DocumentQuestionAnswers_Fragment | TransferNode_Node_DocumentSummary_Fragment | TransferNode_Node_DocumentSummaryPage_Fragment | TransferNode_Node_DocumentSummaryPrompt_Fragment | TransferNode_Node_DocumentSummaryPromptTestRun_Fragment | TransferNode_Node_DocumentSummaryTemplateBundleConfiguration_Fragment | TransferNode_Node_DonorAdvisedFund_Fragment | TransferNode_Node_Employee_Fragment | TransferNode_Node_EntitiesOverviewBundleConfiguration_Fragment | TransferNode_Node_EntitiesOverviewBundleConfigurationEntity_Fragment | TransferNode_Node_Entity_Fragment | TransferNode_Node_EntityDiagram_Fragment | TransferNode_Node_EntityDocumentRelationship_Fragment | TransferNode_Node_EntityGraphView_Fragment | TransferNode_Node_EntityGraphViewBundleConfiguration_Fragment | TransferNode_Node_EntityNotes_Fragment | TransferNode_Node_EntityProposal_Fragment | TransferNode_Node_EntitySummaryBundleConfiguration_Fragment | TransferNode_Node_EntitySummaryTemplateBundleConfiguration_Fragment | TransferNode_Node_EntityTask_Fragment | TransferNode_Node_EntityTaxInfo_Fragment | TransferNode_Node_EstateInsight_Fragment | TransferNode_Node_EstateInsightReference_Fragment | TransferNode_Node_EstateInsightsBundleConfiguration_Fragment | TransferNode_Node_EstateTaxScenario_Fragment | TransferNode_Node_EstateWaterfall_Fragment | TransferNode_Node_EstateWaterfallHypotheticalStateChange_Fragment | TransferNode_Node_EstateWaterfallHypotheticalTransfer_Fragment | TransferNode_Node_EstateWaterfallMessageContext_Fragment | TransferNode_Node_EstateWaterfallVisualizationConfig_Fragment | TransferNode_Node_EstateWaterfallVisualizationFilter_Fragment | TransferNode_Node_FamilyTreeBundleConfiguration_Fragment | TransferNode_Node_FamilyTreeConfiguration_Fragment | TransferNode_Node_FeatureFlag_Fragment | TransferNode_Node_FeatureFlagQueryRule_Fragment | TransferNode_Node_File_Fragment | TransferNode_Node_FilePage_Fragment | TransferNode_Node_FileParagraph_Fragment | TransferNode_Node_Form_Fragment | TransferNode_Node_FormVersion_Fragment | TransferNode_Node_GpBusinessEntity_Fragment | TransferNode_Node_GratAnnuityV2_Fragment | TransferNode_Node_GratProposalScenario_Fragment | TransferNode_Node_GratTrust_Fragment | TransferNode_Node_GiftingProposal_Fragment | TransferNode_Node_GiftingProposalCashFlow_Fragment | TransferNode_Node_GiftingProposalGift_Fragment | TransferNode_Node_GiftingProposalGiftSender_Fragment | TransferNode_Node_GiftingProposalPortfolio_Fragment | TransferNode_Node_GiftingProposalScenario_Fragment | TransferNode_Node_GraphVisualizationGroup_Fragment | TransferNode_Node_GrowthProfile_Fragment | TransferNode_Node_GrowthProfileOverride_Fragment | TransferNode_Node_Household_Fragment | TransferNode_Node_HypotheticalClt_Fragment | TransferNode_Node_HypotheticalCrt_Fragment | TransferNode_Node_HypotheticalGrat_Fragment | TransferNode_Node_HypotheticalInsurance_Fragment | TransferNode_Node_HypotheticalSaleLoan_Fragment | TransferNode_Node_HypotheticalTransferAsset_Fragment | TransferNode_Node_HypotheticalTransferFundingSource_Fragment | TransferNode_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment | TransferNode_Node_IlitCrummeyLetter_Fragment | TransferNode_Node_IlitTrust_Fragment | TransferNode_Node_Image_Fragment | TransferNode_Node_IncomeTaxPaymentConfig_Fragment | TransferNode_Node_IndividualPersonalAccount_Fragment | TransferNode_Node_InferredField_Fragment | TransferNode_Node_InferredFieldEvidence_Fragment | TransferNode_Node_InsightsTemplateBundleConfiguration_Fragment | TransferNode_Node_InsurancePersonalAccount_Fragment | TransferNode_Node_InsurancePolicy_Fragment | TransferNode_Node_InsurancePremiumPayment_Fragment | TransferNode_Node_IntegrationAssetClass_Fragment | TransferNode_Node_IntegrationCashflow_Fragment | TransferNode_Node_IntegrationClient_Fragment | TransferNode_Node_IntegrationConfiguration_Fragment | TransferNode_Node_IntegrationEntity_Fragment | TransferNode_Node_IntegrationInsurance_Fragment | TransferNode_Node_IntegrationLiability_Fragment | TransferNode_Node_IntegrationPerson_Fragment | TransferNode_Node_IrrevocableTrust_Fragment | TransferNode_Node_JointPersonalAccount_Fragment | TransferNode_Node_KgNode_Fragment | TransferNode_Node_KgRelationship_Fragment | TransferNode_Node_KgRoot_Fragment | TransferNode_Node_Kgv2Document_Fragment | TransferNode_Node_Kgv2DocumentChange_Fragment | TransferNode_Node_Kgv2DocumentModification_Fragment | TransferNode_Node_Kgv2Graph_Fragment | TransferNode_Node_Kgv2Node_Fragment | TransferNode_Node_Kgv2NodeAlias_Fragment | TransferNode_Node_Kgv2NodeEvidence_Fragment | TransferNode_Node_Kgv2Statement_Fragment | TransferNode_Node_Kgv2StatementEvidence_Fragment | TransferNode_Node_Kgv2StatementSupersession_Fragment | TransferNode_Node_KeyPerson_Fragment | TransferNode_Node_KeyPersonRole_Fragment | TransferNode_Node_LlcBusinessEntity_Fragment | TransferNode_Node_LpBusinessEntity_Fragment | TransferNode_Node_LiabilitiesBundleConfiguration_Fragment | TransferNode_Node_Liability_Fragment | TransferNode_Node_LiabilityPayment_Fragment | TransferNode_Node_LifeInsuranceBundleConfiguration_Fragment | TransferNode_Node_LifetimeExclusionEvent_Fragment | TransferNode_Node_LoggedTransfer_Fragment | TransferNode_Node_LuminaryOrganization_Fragment | TransferNode_Node_LuminaryTenantJit_Fragment | TransferNode_Node_ManagedSftpConnection_Fragment | TransferNode_Node_Memo_Fragment | TransferNode_Node_MemoPrompt_Fragment | TransferNode_Node_Message_Fragment | TransferNode_Node_MissingDocumentOverride_Fragment | TransferNode_Node_MissingDocumentsPage_Fragment | TransferNode_Node_ModelMapping_Fragment | TransferNode_Node_NotificationApp_Fragment | TransferNode_Node_NotificationPreference_Fragment | TransferNode_Node_OpenaiSdkConfig_Fragment | TransferNode_Node_OrganizationApplicationConfiguration_Fragment | TransferNode_Node_OrganizationDisclaimerConfiguration_Fragment | TransferNode_Node_OwnershipStake_Fragment | TransferNode_Node_PlatformDocument_Fragment | TransferNode_Node_PlatformFile_Fragment | TransferNode_Node_PlatformFilePage_Fragment | TransferNode_Node_PlatformFileParagraph_Fragment | TransferNode_Node_PresentationApprovalRequest_Fragment | TransferNode_Node_PresentationAssetDistributionBundleConfiguration_Fragment | TransferNode_Node_PresentationAssetDistributionItemConfiguration_Fragment | TransferNode_Node_PresentationAssetDistributionItemDetail_Fragment | TransferNode_Node_PresentationBundle_Fragment | TransferNode_Node_PresentationBundleCoverPage_Fragment | TransferNode_Node_PresentationBusinessOverviewBundleConfiguration_Fragment | TransferNode_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment | TransferNode_Node_PresentationBusinessOverviewItem_Fragment | TransferNode_Node_PresentationCoverPage_Fragment | TransferNode_Node_PresentationCoverSlideConfig_Fragment | TransferNode_Node_PresentationCustomPage_Fragment | TransferNode_Node_PresentationCustomPageBundleConfiguration_Fragment | TransferNode_Node_PresentationDiagramPage_Fragment | TransferNode_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment | TransferNode_Node_PresentationDocumentsReviewedDocument_Fragment | TransferNode_Node_PresentationFamilyOverviewBundleConfiguration_Fragment | TransferNode_Node_PresentationFamilyOverviewMemberConfiguration_Fragment | TransferNode_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment | TransferNode_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment | TransferNode_Node_PresentationHealthcareDirectiveItem_Fragment | TransferNode_Node_PresentationItemCitation_Fragment | TransferNode_Node_PresentationPage_Fragment | TransferNode_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment | TransferNode_Node_PresentationPlanningOpportunitiesItem_Fragment | TransferNode_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment | TransferNode_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment | TransferNode_Node_PresentationPowerOfAttorneyItem_Fragment | TransferNode_Node_PresentationTemplate_Fragment | TransferNode_Node_PresentationTemplateBundle_Fragment | TransferNode_Node_PresentationTemplateCoverPage_Fragment | TransferNode_Node_PresentationTemplateCustomPage_Fragment | TransferNode_Node_PresentationTemplateDiagramPage_Fragment | TransferNode_Node_PresentationTemplatePage_Fragment | TransferNode_Node_PresentationTrustOverviewBundleConfiguration_Fragment | TransferNode_Node_PresentationTrustOverviewItem_Fragment | TransferNode_Node_PresentationTrustOverviewTrustConfiguration_Fragment | TransferNode_Node_PresentationWillBundleConfiguration_Fragment | TransferNode_Node_PresentationWillClientConfiguration_Fragment | TransferNode_Node_PresentationWillItem_Fragment | TransferNode_Node_Principal_Fragment | TransferNode_Node_PrivateFoundation_Fragment | TransferNode_Node_ProfessionalTeamRole_Fragment | TransferNode_Node_Proposal_Fragment | TransferNode_Node_ProposalScenario_Fragment | TransferNode_Node_QprtTrust_Fragment | TransferNode_Node_QualifiedTuitionPersonalAccount_Fragment | TransferNode_Node_ReleaseGroup_Fragment | TransferNode_Node_ReminderEmailNotificationRecord_Fragment | TransferNode_Node_RetirementPersonalAccount_Fragment | TransferNode_Node_RevocableTrust_Fragment | TransferNode_Node_Role_Fragment | TransferNode_Node_SCorpBusinessEntity_Fragment | TransferNode_Node_SlatTrust_Fragment | TransferNode_Node_SsoConnection_Fragment | TransferNode_Node_SalesforceExportAttempt_Fragment | TransferNode_Node_ScheduledDistribution_Fragment | TransferNode_Node_SoleProprietorshipBusinessEntity_Fragment | TransferNode_Node_SubBrand_Fragment | TransferNode_Node_SubBrandDisclaimerConfiguration_Fragment | TransferNode_Node_Submission_Fragment | TransferNode_Node_TaxDragConfig_Fragment | TransferNode_Node_TaxDragOverride_Fragment | TransferNode_Node_Team_Fragment | TransferNode_Node_Tenant_Fragment | TransferNode_Node_TenantApplicationConfiguration_Fragment | TransferNode_Node_TenantBranding_Fragment | TransferNode_Node_TenantDisclaimerConfiguration_Fragment | TransferNode_Node_TenantDocument_Fragment | TransferNode_Node_TenantReminderEmailsConfiguration_Fragment | TransferNode_Node_TenantSsoConnection_Fragment | TransferNode_Node_TenantSecurityConfiguration_Fragment | TransferNode_Node_TenantSlideConfig_Fragment | TransferNode_Node_TestCmkEncryption_Fragment | TransferNode_Node_TestamentaryEntity_Fragment | TransferNode_Node_TrustAdvisor_Fragment | TransferNode_Node_TrustAdvisorRole_Fragment | TransferNode_Node_Trustee_Fragment | TransferNode_Node_TrusteeDuty_Fragment | TransferNode_Node_User_Fragment | TransferNode_Node_UserFeedback_Fragment | TransferNode_Node_UserNotificationConfiguration_Fragment | TransferNode_Node_WaterfallBundleConfiguration_Fragment | TransferNode_Node_WaterfallBundleCoverPage_Fragment | TransferNode_Node_WaterfallComparisonBundleConfiguration_Fragment | TransferNode_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment | TransferNode_Node_WaterfallTemplateBundleConfiguration_Fragment | TransferNode_Node_WorkOsOrganization_Fragment | TransferNode_Node_WorkOsOrganizationDomain_Fragment | TransferNode_Node_WorkflowTracker_Fragment;

export type GetHypotheticalTransfers_EstateWaterfallTransferFragment = { __typename?: 'EstateWaterfallTransfer', year: number, kind: Types.EstateWaterfallTransferKind, finalTransferAmount?: CurrencyUSD | null, associatedObjectID?: string | null, source?: { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string, node: (
      { __typename?: 'AISuggestion' }
      & TransferNode_Node_AiSuggestion_Fragment
    ) | (
      { __typename?: 'AISuggestionEvidence' }
      & TransferNode_Node_AiSuggestionEvidence_Fragment
    ) | (
      { __typename?: 'AccessAgeParameter' }
      & TransferNode_Node_AccessAgeParameter_Fragment
    ) | (
      { __typename?: 'AccessParameter' }
      & TransferNode_Node_AccessParameter_Fragment
    ) | (
      { __typename?: 'Account' }
      & TransferNode_Node_Account_Fragment
    ) | (
      { __typename?: 'ActiveEstateInsightsPage' }
      & TransferNode_Node_ActiveEstateInsightsPage_Fragment
    ) | (
      { __typename?: 'Activity' }
      & TransferNode_Node_Activity_Fragment
    ) | (
      { __typename?: 'Address' }
      & TransferNode_Node_Address_Fragment
    ) | (
      { __typename?: 'Answer' }
      & TransferNode_Node_Answer_Fragment
    ) | (
      { __typename?: 'AnswerEvidence' }
      & TransferNode_Node_AnswerEvidence_Fragment
    ) | (
      { __typename?: 'AnswerRevision' }
      & TransferNode_Node_AnswerRevision_Fragment
    ) | (
      { __typename?: 'Approval' }
      & TransferNode_Node_Approval_Fragment
    ) | (
      { __typename?: 'AssetClass' }
      & TransferNode_Node_AssetClass_Fragment
    ) | (
      { __typename?: 'AssetGroup' }
      & TransferNode_Node_AssetGroup_Fragment
    ) | (
      { __typename?: 'AssetStatic' }
      & TransferNode_Node_AssetStatic_Fragment
    ) | (
      { __typename?: 'AssetV2' }
      & TransferNode_Node_AssetV2_Fragment
    ) | (
      { __typename?: 'AssetValuationV2' }
      & TransferNode_Node_AssetValuationV2_Fragment
    ) | (
      { __typename?: 'AssetValueV2' }
      & TransferNode_Node_AssetValueV2_Fragment
    ) | (
      { __typename?: 'AsyncJob' }
      & TransferNode_Node_AsyncJob_Fragment
    ) | (
      { __typename?: 'BalanceSheetBundleConfiguration' }
      & TransferNode_Node_BalanceSheetBundleConfiguration_Fragment
    ) | (
      { __typename?: 'BalanceSheetCategory' }
      & TransferNode_Node_BalanceSheetCategory_Fragment
    ) | (
      { __typename?: 'BalanceSheetViewConfiguration' }
      & TransferNode_Node_BalanceSheetViewConfiguration_Fragment
    ) | (
      { __typename?: 'BeneficiariesBundleConfiguration' }
      & TransferNode_Node_BeneficiariesBundleConfiguration_Fragment
    ) | (
      { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
      & TransferNode_Node_BeneficiariesTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'Beneficiary' }
      & TransferNode_Node_Beneficiary_Fragment
    ) | (
      { __typename?: 'BeneficiaryAccessParameter' }
      & TransferNode_Node_BeneficiaryAccessParameter_Fragment
    ) | (
      { __typename?: 'BeneficiaryDesignationGroup' }
      & TransferNode_Node_BeneficiaryDesignationGroup_Fragment
    ) | (
      { __typename?: 'BeneficiaryDistribution' }
      & TransferNode_Node_BeneficiaryDistribution_Fragment
    ) | (
      { __typename?: 'BeneficiaryDistributionParameter' }
      & TransferNode_Node_BeneficiaryDistributionParameter_Fragment
    ) | (
      { __typename?: 'BeneficiaryPage' }
      & TransferNode_Node_BeneficiaryPage_Fragment
    ) | (
      { __typename?: 'BeneficiaryPowerOfAppointment' }
      & TransferNode_Node_BeneficiaryPowerOfAppointment_Fragment
    ) | (
      { __typename?: 'CCorpBusinessEntity' }
      & TransferNode_Node_CCorpBusinessEntity_Fragment
    ) | (
      { __typename?: 'CLTProposal' }
      & TransferNode_Node_CltProposal_Fragment
    ) | (
      { __typename?: 'CLTTrust' }
      & TransferNode_Node_CltTrust_Fragment
    ) | (
      { __typename?: 'CRTProposal' }
      & TransferNode_Node_CrtProposal_Fragment
    ) | (
      { __typename?: 'CRTTrust' }
      & TransferNode_Node_CrtTrust_Fragment
    ) | (
      { __typename?: 'Capability' }
      & TransferNode_Node_Capability_Fragment
    ) | (
      { __typename?: 'Cashflow' }
      & TransferNode_Node_Cashflow_Fragment
    ) | (
      { __typename?: 'ClientOrganization' }
      & TransferNode_Node_ClientOrganization_Fragment
    ) | (
      { __typename?: 'ClientPresentationV2' }
      & TransferNode_Node_ClientPresentationV2_Fragment
    ) | (
      { __typename?: 'ClientProfile' }
      & TransferNode_Node_ClientProfile_Fragment
    ) | (
      { __typename?: 'ClientProfileRelationship' }
      & TransferNode_Node_ClientProfileRelationship_Fragment
    ) | (
      { __typename?: 'Collaborator' }
      & TransferNode_Node_Collaborator_Fragment
    ) | (
      { __typename?: 'ComparedWaterfall' }
      & TransferNode_Node_ComparedWaterfall_Fragment
    ) | (
      { __typename?: 'CompletedEstateInsightsPage' }
      & TransferNode_Node_CompletedEstateInsightsPage_Fragment
    ) | (
      { __typename?: 'ControllingParty' }
      & TransferNode_Node_ControllingParty_Fragment
    ) | (
      { __typename?: 'Conversation' }
      & TransferNode_Node_Conversation_Fragment
    ) | (
      { __typename?: 'CoverPageConfiguration' }
      & TransferNode_Node_CoverPageConfiguration_Fragment
    ) | (
      { __typename?: 'CustodialPersonalAccount' }
      & TransferNode_Node_CustodialPersonalAccount_Fragment
    ) | (
      { __typename?: 'DSUEPortability' }
      & TransferNode_Node_DsuePortability_Fragment
    ) | (
      { __typename?: 'DiagramArtifact' }
      & TransferNode_Node_DiagramArtifact_Fragment
    ) | (
      { __typename?: 'DiagramArtifactPrompt' }
      & TransferNode_Node_DiagramArtifactPrompt_Fragment
    ) | (
      { __typename?: 'DispositionScenario' }
      & TransferNode_Node_DispositionScenario_Fragment
    ) | (
      { __typename?: 'DispositiveProvision' }
      & TransferNode_Node_DispositiveProvision_Fragment
    ) | (
      { __typename?: 'DispositiveProvisionTemplate' }
      & TransferNode_Node_DispositiveProvisionTemplate_Fragment
    ) | (
      { __typename?: 'DividerBundleConfiguration' }
      & TransferNode_Node_DividerBundleConfiguration_Fragment
    ) | (
      { __typename?: 'DividerTemplateBundleConfiguration' }
      & TransferNode_Node_DividerTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'Document' }
      & TransferNode_Node_Document_Fragment
    ) | (
      { __typename?: 'DocumentQuestion' }
      & TransferNode_Node_DocumentQuestion_Fragment
    ) | (
      { __typename?: 'DocumentQuestionAnswers' }
      & TransferNode_Node_DocumentQuestionAnswers_Fragment
    ) | (
      { __typename?: 'DocumentSummary' }
      & TransferNode_Node_DocumentSummary_Fragment
    ) | (
      { __typename?: 'DocumentSummaryPage' }
      & TransferNode_Node_DocumentSummaryPage_Fragment
    ) | (
      { __typename?: 'DocumentSummaryPrompt' }
      & TransferNode_Node_DocumentSummaryPrompt_Fragment
    ) | (
      { __typename?: 'DocumentSummaryPromptTestRun' }
      & TransferNode_Node_DocumentSummaryPromptTestRun_Fragment
    ) | (
      { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
      & TransferNode_Node_DocumentSummaryTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'DonorAdvisedFund' }
      & TransferNode_Node_DonorAdvisedFund_Fragment
    ) | (
      { __typename?: 'Employee' }
      & TransferNode_Node_Employee_Fragment
    ) | (
      { __typename?: 'EntitiesOverviewBundleConfiguration' }
      & TransferNode_Node_EntitiesOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
      & TransferNode_Node_EntitiesOverviewBundleConfigurationEntity_Fragment
    ) | (
      { __typename?: 'Entity' }
      & TransferNode_Node_Entity_Fragment
    ) | (
      { __typename?: 'EntityDiagram' }
      & TransferNode_Node_EntityDiagram_Fragment
    ) | (
      { __typename?: 'EntityDocumentRelationship' }
      & TransferNode_Node_EntityDocumentRelationship_Fragment
    ) | (
      { __typename?: 'EntityGraphView' }
      & TransferNode_Node_EntityGraphView_Fragment
    ) | (
      { __typename?: 'EntityGraphViewBundleConfiguration' }
      & TransferNode_Node_EntityGraphViewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntityNotes' }
      & TransferNode_Node_EntityNotes_Fragment
    ) | (
      { __typename?: 'EntityProposal' }
      & TransferNode_Node_EntityProposal_Fragment
    ) | (
      { __typename?: 'EntitySummaryBundleConfiguration' }
      & TransferNode_Node_EntitySummaryBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
      & TransferNode_Node_EntitySummaryTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntityTask' }
      & TransferNode_Node_EntityTask_Fragment
    ) | (
      { __typename?: 'EntityTaxInfo' }
      & TransferNode_Node_EntityTaxInfo_Fragment
    ) | (
      { __typename?: 'EstateInsight' }
      & TransferNode_Node_EstateInsight_Fragment
    ) | (
      { __typename?: 'EstateInsightReference' }
      & TransferNode_Node_EstateInsightReference_Fragment
    ) | (
      { __typename?: 'EstateInsightsBundleConfiguration' }
      & TransferNode_Node_EstateInsightsBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EstateTaxScenario' }
      & TransferNode_Node_EstateTaxScenario_Fragment
    ) | (
      { __typename?: 'EstateWaterfall' }
      & TransferNode_Node_EstateWaterfall_Fragment
    ) | (
      { __typename?: 'EstateWaterfallHypotheticalStateChange' }
      & TransferNode_Node_EstateWaterfallHypotheticalStateChange_Fragment
    ) | (
      { __typename?: 'EstateWaterfallHypotheticalTransfer' }
      & TransferNode_Node_EstateWaterfallHypotheticalTransfer_Fragment
    ) | (
      { __typename?: 'EstateWaterfallMessageContext' }
      & TransferNode_Node_EstateWaterfallMessageContext_Fragment
    ) | (
      { __typename?: 'EstateWaterfallVisualizationConfig' }
      & TransferNode_Node_EstateWaterfallVisualizationConfig_Fragment
    ) | (
      { __typename?: 'EstateWaterfallVisualizationFilter' }
      & TransferNode_Node_EstateWaterfallVisualizationFilter_Fragment
    ) | (
      { __typename?: 'FamilyTreeBundleConfiguration' }
      & TransferNode_Node_FamilyTreeBundleConfiguration_Fragment
    ) | (
      { __typename?: 'FamilyTreeConfiguration' }
      & TransferNode_Node_FamilyTreeConfiguration_Fragment
    ) | (
      { __typename?: 'FeatureFlag' }
      & TransferNode_Node_FeatureFlag_Fragment
    ) | (
      { __typename?: 'FeatureFlagQueryRule' }
      & TransferNode_Node_FeatureFlagQueryRule_Fragment
    ) | (
      { __typename?: 'File' }
      & TransferNode_Node_File_Fragment
    ) | (
      { __typename?: 'FilePage' }
      & TransferNode_Node_FilePage_Fragment
    ) | (
      { __typename?: 'FileParagraph' }
      & TransferNode_Node_FileParagraph_Fragment
    ) | (
      { __typename?: 'Form' }
      & TransferNode_Node_Form_Fragment
    ) | (
      { __typename?: 'FormVersion' }
      & TransferNode_Node_FormVersion_Fragment
    ) | (
      { __typename?: 'GPBusinessEntity' }
      & TransferNode_Node_GpBusinessEntity_Fragment
    ) | (
      { __typename?: 'GRATAnnuityV2' }
      & TransferNode_Node_GratAnnuityV2_Fragment
    ) | (
      { __typename?: 'GRATProposalScenario' }
      & TransferNode_Node_GratProposalScenario_Fragment
    ) | (
      { __typename?: 'GRATTrust' }
      & TransferNode_Node_GratTrust_Fragment
    ) | (
      { __typename?: 'GiftingProposal' }
      & TransferNode_Node_GiftingProposal_Fragment
    ) | (
      { __typename?: 'GiftingProposalCashFlow' }
      & TransferNode_Node_GiftingProposalCashFlow_Fragment
    ) | (
      { __typename?: 'GiftingProposalGift' }
      & TransferNode_Node_GiftingProposalGift_Fragment
    ) | (
      { __typename?: 'GiftingProposalGiftSender' }
      & TransferNode_Node_GiftingProposalGiftSender_Fragment
    ) | (
      { __typename?: 'GiftingProposalPortfolio' }
      & TransferNode_Node_GiftingProposalPortfolio_Fragment
    ) | (
      { __typename?: 'GiftingProposalScenario' }
      & TransferNode_Node_GiftingProposalScenario_Fragment
    ) | (
      { __typename?: 'GraphVisualizationGroup' }
      & TransferNode_Node_GraphVisualizationGroup_Fragment
    ) | (
      { __typename?: 'GrowthProfile' }
      & TransferNode_Node_GrowthProfile_Fragment
    ) | (
      { __typename?: 'GrowthProfileOverride' }
      & TransferNode_Node_GrowthProfileOverride_Fragment
    ) | (
      { __typename?: 'Household' }
      & TransferNode_Node_Household_Fragment
    ) | (
      { __typename?: 'HypotheticalCLT' }
      & TransferNode_Node_HypotheticalClt_Fragment
    ) | (
      { __typename?: 'HypotheticalCRT' }
      & TransferNode_Node_HypotheticalCrt_Fragment
    ) | (
      { __typename?: 'HypotheticalGRAT' }
      & TransferNode_Node_HypotheticalGrat_Fragment
    ) | (
      { __typename?: 'HypotheticalInsurance' }
      & TransferNode_Node_HypotheticalInsurance_Fragment
    ) | (
      { __typename?: 'HypotheticalSaleLoan' }
      & TransferNode_Node_HypotheticalSaleLoan_Fragment
    ) | (
      { __typename?: 'HypotheticalTransferAsset' }
      & TransferNode_Node_HypotheticalTransferAsset_Fragment
    ) | (
      { __typename?: 'HypotheticalTransferFundingSource' }
      & TransferNode_Node_HypotheticalTransferFundingSource_Fragment
    ) | (
      { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
      & TransferNode_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
    ) | (
      { __typename?: 'ILITCrummeyLetter' }
      & TransferNode_Node_IlitCrummeyLetter_Fragment
    ) | (
      { __typename?: 'ILITTrust' }
      & TransferNode_Node_IlitTrust_Fragment
    ) | (
      { __typename?: 'Image' }
      & TransferNode_Node_Image_Fragment
    ) | (
      { __typename?: 'IncomeTaxPaymentConfig' }
      & TransferNode_Node_IncomeTaxPaymentConfig_Fragment
    ) | (
      { __typename?: 'IndividualPersonalAccount' }
      & TransferNode_Node_IndividualPersonalAccount_Fragment
    ) | (
      { __typename?: 'InferredField' }
      & TransferNode_Node_InferredField_Fragment
    ) | (
      { __typename?: 'InferredFieldEvidence' }
      & TransferNode_Node_InferredFieldEvidence_Fragment
    ) | (
      { __typename?: 'InsightsTemplateBundleConfiguration' }
      & TransferNode_Node_InsightsTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'InsurancePersonalAccount' }
      & TransferNode_Node_InsurancePersonalAccount_Fragment
    ) | (
      { __typename?: 'InsurancePolicy' }
      & TransferNode_Node_InsurancePolicy_Fragment
    ) | (
      { __typename?: 'InsurancePremiumPayment' }
      & TransferNode_Node_InsurancePremiumPayment_Fragment
    ) | (
      { __typename?: 'IntegrationAssetClass' }
      & TransferNode_Node_IntegrationAssetClass_Fragment
    ) | (
      { __typename?: 'IntegrationCashflow' }
      & TransferNode_Node_IntegrationCashflow_Fragment
    ) | (
      { __typename?: 'IntegrationClient' }
      & TransferNode_Node_IntegrationClient_Fragment
    ) | (
      { __typename?: 'IntegrationConfiguration' }
      & TransferNode_Node_IntegrationConfiguration_Fragment
    ) | (
      { __typename?: 'IntegrationEntity' }
      & TransferNode_Node_IntegrationEntity_Fragment
    ) | (
      { __typename?: 'IntegrationInsurance' }
      & TransferNode_Node_IntegrationInsurance_Fragment
    ) | (
      { __typename?: 'IntegrationLiability' }
      & TransferNode_Node_IntegrationLiability_Fragment
    ) | (
      { __typename?: 'IntegrationPerson' }
      & TransferNode_Node_IntegrationPerson_Fragment
    ) | (
      { __typename?: 'IrrevocableTrust' }
      & TransferNode_Node_IrrevocableTrust_Fragment
    ) | (
      { __typename?: 'JointPersonalAccount' }
      & TransferNode_Node_JointPersonalAccount_Fragment
    ) | (
      { __typename?: 'KGNode' }
      & TransferNode_Node_KgNode_Fragment
    ) | (
      { __typename?: 'KGRelationship' }
      & TransferNode_Node_KgRelationship_Fragment
    ) | (
      { __typename?: 'KGRoot' }
      & TransferNode_Node_KgRoot_Fragment
    ) | (
      { __typename?: 'KGV2Document' }
      & TransferNode_Node_Kgv2Document_Fragment
    ) | (
      { __typename?: 'KGV2DocumentChange' }
      & TransferNode_Node_Kgv2DocumentChange_Fragment
    ) | (
      { __typename?: 'KGV2DocumentModification' }
      & TransferNode_Node_Kgv2DocumentModification_Fragment
    ) | (
      { __typename?: 'KGV2Graph' }
      & TransferNode_Node_Kgv2Graph_Fragment
    ) | (
      { __typename?: 'KGV2Node' }
      & TransferNode_Node_Kgv2Node_Fragment
    ) | (
      { __typename?: 'KGV2NodeAlias' }
      & TransferNode_Node_Kgv2NodeAlias_Fragment
    ) | (
      { __typename?: 'KGV2NodeEvidence' }
      & TransferNode_Node_Kgv2NodeEvidence_Fragment
    ) | (
      { __typename?: 'KGV2Statement' }
      & TransferNode_Node_Kgv2Statement_Fragment
    ) | (
      { __typename?: 'KGV2StatementEvidence' }
      & TransferNode_Node_Kgv2StatementEvidence_Fragment
    ) | (
      { __typename?: 'KGV2StatementSupersession' }
      & TransferNode_Node_Kgv2StatementSupersession_Fragment
    ) | (
      { __typename?: 'KeyPerson' }
      & TransferNode_Node_KeyPerson_Fragment
    ) | (
      { __typename?: 'KeyPersonRole' }
      & TransferNode_Node_KeyPersonRole_Fragment
    ) | (
      { __typename?: 'LLCBusinessEntity' }
      & TransferNode_Node_LlcBusinessEntity_Fragment
    ) | (
      { __typename?: 'LPBusinessEntity' }
      & TransferNode_Node_LpBusinessEntity_Fragment
    ) | (
      { __typename?: 'LiabilitiesBundleConfiguration' }
      & TransferNode_Node_LiabilitiesBundleConfiguration_Fragment
    ) | (
      { __typename?: 'Liability' }
      & TransferNode_Node_Liability_Fragment
    ) | (
      { __typename?: 'LiabilityPayment' }
      & TransferNode_Node_LiabilityPayment_Fragment
    ) | (
      { __typename?: 'LifeInsuranceBundleConfiguration' }
      & TransferNode_Node_LifeInsuranceBundleConfiguration_Fragment
    ) | (
      { __typename?: 'LifetimeExclusionEvent' }
      & TransferNode_Node_LifetimeExclusionEvent_Fragment
    ) | (
      { __typename?: 'LoggedTransfer' }
      & TransferNode_Node_LoggedTransfer_Fragment
    ) | (
      { __typename?: 'LuminaryOrganization' }
      & TransferNode_Node_LuminaryOrganization_Fragment
    ) | (
      { __typename?: 'LuminaryTenantJIT' }
      & TransferNode_Node_LuminaryTenantJit_Fragment
    ) | (
      { __typename?: 'ManagedSFTPConnection' }
      & TransferNode_Node_ManagedSftpConnection_Fragment
    ) | (
      { __typename?: 'Memo' }
      & TransferNode_Node_Memo_Fragment
    ) | (
      { __typename?: 'MemoPrompt' }
      & TransferNode_Node_MemoPrompt_Fragment
    ) | (
      { __typename?: 'Message' }
      & TransferNode_Node_Message_Fragment
    ) | (
      { __typename?: 'MissingDocumentOverride' }
      & TransferNode_Node_MissingDocumentOverride_Fragment
    ) | (
      { __typename?: 'MissingDocumentsPage' }
      & TransferNode_Node_MissingDocumentsPage_Fragment
    ) | (
      { __typename?: 'ModelMapping' }
      & TransferNode_Node_ModelMapping_Fragment
    ) | (
      { __typename?: 'NotificationApp' }
      & TransferNode_Node_NotificationApp_Fragment
    ) | (
      { __typename?: 'NotificationPreference' }
      & TransferNode_Node_NotificationPreference_Fragment
    ) | (
      { __typename?: 'OpenaiSdkConfig' }
      & TransferNode_Node_OpenaiSdkConfig_Fragment
    ) | (
      { __typename?: 'OrganizationApplicationConfiguration' }
      & TransferNode_Node_OrganizationApplicationConfiguration_Fragment
    ) | (
      { __typename?: 'OrganizationDisclaimerConfiguration' }
      & TransferNode_Node_OrganizationDisclaimerConfiguration_Fragment
    ) | (
      { __typename?: 'OwnershipStake' }
      & TransferNode_Node_OwnershipStake_Fragment
    ) | (
      { __typename?: 'PlatformDocument' }
      & TransferNode_Node_PlatformDocument_Fragment
    ) | (
      { __typename?: 'PlatformFile' }
      & TransferNode_Node_PlatformFile_Fragment
    ) | (
      { __typename?: 'PlatformFilePage' }
      & TransferNode_Node_PlatformFilePage_Fragment
    ) | (
      { __typename?: 'PlatformFileParagraph' }
      & TransferNode_Node_PlatformFileParagraph_Fragment
    ) | (
      { __typename?: 'PresentationApprovalRequest' }
      & TransferNode_Node_PresentationApprovalRequest_Fragment
    ) | (
      { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
      & TransferNode_Node_PresentationAssetDistributionBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationAssetDistributionItemConfiguration' }
      & TransferNode_Node_PresentationAssetDistributionItemConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationAssetDistributionItemDetail' }
      & TransferNode_Node_PresentationAssetDistributionItemDetail_Fragment
    ) | (
      { __typename?: 'PresentationBundle' }
      & TransferNode_Node_PresentationBundle_Fragment
    ) | (
      { __typename?: 'PresentationBundleCoverPage' }
      & TransferNode_Node_PresentationBundleCoverPage_Fragment
    ) | (
      { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
      & TransferNode_Node_PresentationBusinessOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
      & TransferNode_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationBusinessOverviewItem' }
      & TransferNode_Node_PresentationBusinessOverviewItem_Fragment
    ) | (
      { __typename?: 'PresentationCoverPage' }
      & TransferNode_Node_PresentationCoverPage_Fragment
    ) | (
      { __typename?: 'PresentationCoverSlideConfig' }
      & TransferNode_Node_PresentationCoverSlideConfig_Fragment
    ) | (
      { __typename?: 'PresentationCustomPage' }
      & TransferNode_Node_PresentationCustomPage_Fragment
    ) | (
      { __typename?: 'PresentationCustomPageBundleConfiguration' }
      & TransferNode_Node_PresentationCustomPageBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationDiagramPage' }
      & TransferNode_Node_PresentationDiagramPage_Fragment
    ) | (
      { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
      & TransferNode_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationDocumentsReviewedDocument' }
      & TransferNode_Node_PresentationDocumentsReviewedDocument_Fragment
    ) | (
      { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
      & TransferNode_Node_PresentationFamilyOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
      & TransferNode_Node_PresentationFamilyOverviewMemberConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
      & TransferNode_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
      & TransferNode_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationHealthcareDirectiveItem' }
      & TransferNode_Node_PresentationHealthcareDirectiveItem_Fragment
    ) | (
      { __typename?: 'PresentationItemCitation' }
      & TransferNode_Node_PresentationItemCitation_Fragment
    ) | (
      { __typename?: 'PresentationPage' }
      & TransferNode_Node_PresentationPage_Fragment
    ) | (
      { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
      & TransferNode_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationPlanningOpportunitiesItem' }
      & TransferNode_Node_PresentationPlanningOpportunitiesItem_Fragment
    ) | (
      { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
      & TransferNode_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
      & TransferNode_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationPowerOfAttorneyItem' }
      & TransferNode_Node_PresentationPowerOfAttorneyItem_Fragment
    ) | (
      { __typename?: 'PresentationTemplate' }
      & TransferNode_Node_PresentationTemplate_Fragment
    ) | (
      { __typename?: 'PresentationTemplateBundle' }
      & TransferNode_Node_PresentationTemplateBundle_Fragment
    ) | (
      { __typename?: 'PresentationTemplateCoverPage' }
      & TransferNode_Node_PresentationTemplateCoverPage_Fragment
    ) | (
      { __typename?: 'PresentationTemplateCustomPage' }
      & TransferNode_Node_PresentationTemplateCustomPage_Fragment
    ) | (
      { __typename?: 'PresentationTemplateDiagramPage' }
      & TransferNode_Node_PresentationTemplateDiagramPage_Fragment
    ) | (
      { __typename?: 'PresentationTemplatePage' }
      & TransferNode_Node_PresentationTemplatePage_Fragment
    ) | (
      { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
      & TransferNode_Node_PresentationTrustOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationTrustOverviewItem' }
      & TransferNode_Node_PresentationTrustOverviewItem_Fragment
    ) | (
      { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
      & TransferNode_Node_PresentationTrustOverviewTrustConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationWillBundleConfiguration' }
      & TransferNode_Node_PresentationWillBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationWillClientConfiguration' }
      & TransferNode_Node_PresentationWillClientConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationWillItem' }
      & TransferNode_Node_PresentationWillItem_Fragment
    ) | (
      { __typename?: 'Principal' }
      & TransferNode_Node_Principal_Fragment
    ) | (
      { __typename?: 'PrivateFoundation' }
      & TransferNode_Node_PrivateFoundation_Fragment
    ) | (
      { __typename?: 'ProfessionalTeamRole' }
      & TransferNode_Node_ProfessionalTeamRole_Fragment
    ) | (
      { __typename?: 'Proposal' }
      & TransferNode_Node_Proposal_Fragment
    ) | (
      { __typename?: 'ProposalScenario' }
      & TransferNode_Node_ProposalScenario_Fragment
    ) | (
      { __typename?: 'QPRTTrust' }
      & TransferNode_Node_QprtTrust_Fragment
    ) | (
      { __typename?: 'QualifiedTuitionPersonalAccount' }
      & TransferNode_Node_QualifiedTuitionPersonalAccount_Fragment
    ) | (
      { __typename?: 'ReleaseGroup' }
      & TransferNode_Node_ReleaseGroup_Fragment
    ) | (
      { __typename?: 'ReminderEmailNotificationRecord' }
      & TransferNode_Node_ReminderEmailNotificationRecord_Fragment
    ) | (
      { __typename?: 'RetirementPersonalAccount' }
      & TransferNode_Node_RetirementPersonalAccount_Fragment
    ) | (
      { __typename?: 'RevocableTrust' }
      & TransferNode_Node_RevocableTrust_Fragment
    ) | (
      { __typename?: 'Role' }
      & TransferNode_Node_Role_Fragment
    ) | (
      { __typename?: 'SCorpBusinessEntity' }
      & TransferNode_Node_SCorpBusinessEntity_Fragment
    ) | (
      { __typename?: 'SLATTrust' }
      & TransferNode_Node_SlatTrust_Fragment
    ) | (
      { __typename?: 'SSOConnection' }
      & TransferNode_Node_SsoConnection_Fragment
    ) | (
      { __typename?: 'SalesforceExportAttempt' }
      & TransferNode_Node_SalesforceExportAttempt_Fragment
    ) | (
      { __typename?: 'ScheduledDistribution' }
      & TransferNode_Node_ScheduledDistribution_Fragment
    ) | (
      { __typename?: 'SoleProprietorshipBusinessEntity' }
      & TransferNode_Node_SoleProprietorshipBusinessEntity_Fragment
    ) | (
      { __typename?: 'SubBrand' }
      & TransferNode_Node_SubBrand_Fragment
    ) | (
      { __typename?: 'SubBrandDisclaimerConfiguration' }
      & TransferNode_Node_SubBrandDisclaimerConfiguration_Fragment
    ) | (
      { __typename?: 'Submission' }
      & TransferNode_Node_Submission_Fragment
    ) | (
      { __typename?: 'TaxDragConfig' }
      & TransferNode_Node_TaxDragConfig_Fragment
    ) | (
      { __typename?: 'TaxDragOverride' }
      & TransferNode_Node_TaxDragOverride_Fragment
    ) | (
      { __typename?: 'Team' }
      & TransferNode_Node_Team_Fragment
    ) | (
      { __typename?: 'Tenant' }
      & TransferNode_Node_Tenant_Fragment
    ) | (
      { __typename?: 'TenantApplicationConfiguration' }
      & TransferNode_Node_TenantApplicationConfiguration_Fragment
    ) | (
      { __typename?: 'TenantBranding' }
      & TransferNode_Node_TenantBranding_Fragment
    ) | (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & TransferNode_Node_TenantDisclaimerConfiguration_Fragment
    ) | (
      { __typename?: 'TenantDocument' }
      & TransferNode_Node_TenantDocument_Fragment
    ) | (
      { __typename?: 'TenantReminderEmailsConfiguration' }
      & TransferNode_Node_TenantReminderEmailsConfiguration_Fragment
    ) | (
      { __typename?: 'TenantSSOConnection' }
      & TransferNode_Node_TenantSsoConnection_Fragment
    ) | (
      { __typename?: 'TenantSecurityConfiguration' }
      & TransferNode_Node_TenantSecurityConfiguration_Fragment
    ) | (
      { __typename?: 'TenantSlideConfig' }
      & TransferNode_Node_TenantSlideConfig_Fragment
    ) | (
      { __typename?: 'TestCMKEncryption' }
      & TransferNode_Node_TestCmkEncryption_Fragment
    ) | (
      { __typename?: 'TestamentaryEntity' }
      & TransferNode_Node_TestamentaryEntity_Fragment
    ) | (
      { __typename?: 'TrustAdvisor' }
      & TransferNode_Node_TrustAdvisor_Fragment
    ) | (
      { __typename?: 'TrustAdvisorRole' }
      & TransferNode_Node_TrustAdvisorRole_Fragment
    ) | (
      { __typename?: 'Trustee' }
      & TransferNode_Node_Trustee_Fragment
    ) | (
      { __typename?: 'TrusteeDuty' }
      & TransferNode_Node_TrusteeDuty_Fragment
    ) | (
      { __typename?: 'User' }
      & TransferNode_Node_User_Fragment
    ) | (
      { __typename?: 'UserFeedback' }
      & TransferNode_Node_UserFeedback_Fragment
    ) | (
      { __typename?: 'UserNotificationConfiguration' }
      & TransferNode_Node_UserNotificationConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallBundleConfiguration' }
      & TransferNode_Node_WaterfallBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallBundleCoverPage' }
      & TransferNode_Node_WaterfallBundleCoverPage_Fragment
    ) | (
      { __typename?: 'WaterfallComparisonBundleConfiguration' }
      & TransferNode_Node_WaterfallComparisonBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
      & TransferNode_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallTemplateBundleConfiguration' }
      & TransferNode_Node_WaterfallTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WorkOSOrganization' }
      & TransferNode_Node_WorkOsOrganization_Fragment
    ) | (
      { __typename?: 'WorkOSOrganizationDomain' }
      & TransferNode_Node_WorkOsOrganizationDomain_Fragment
    ) | (
      { __typename?: 'WorkflowTracker' }
      & TransferNode_Node_WorkflowTracker_Fragment
    ) } | null, destination?: { __typename?: 'EstateWaterfallVizNode', _cacheKey: string, id: string, node: (
      { __typename?: 'AISuggestion' }
      & TransferNode_Node_AiSuggestion_Fragment
    ) | (
      { __typename?: 'AISuggestionEvidence' }
      & TransferNode_Node_AiSuggestionEvidence_Fragment
    ) | (
      { __typename?: 'AccessAgeParameter' }
      & TransferNode_Node_AccessAgeParameter_Fragment
    ) | (
      { __typename?: 'AccessParameter' }
      & TransferNode_Node_AccessParameter_Fragment
    ) | (
      { __typename?: 'Account' }
      & TransferNode_Node_Account_Fragment
    ) | (
      { __typename?: 'ActiveEstateInsightsPage' }
      & TransferNode_Node_ActiveEstateInsightsPage_Fragment
    ) | (
      { __typename?: 'Activity' }
      & TransferNode_Node_Activity_Fragment
    ) | (
      { __typename?: 'Address' }
      & TransferNode_Node_Address_Fragment
    ) | (
      { __typename?: 'Answer' }
      & TransferNode_Node_Answer_Fragment
    ) | (
      { __typename?: 'AnswerEvidence' }
      & TransferNode_Node_AnswerEvidence_Fragment
    ) | (
      { __typename?: 'AnswerRevision' }
      & TransferNode_Node_AnswerRevision_Fragment
    ) | (
      { __typename?: 'Approval' }
      & TransferNode_Node_Approval_Fragment
    ) | (
      { __typename?: 'AssetClass' }
      & TransferNode_Node_AssetClass_Fragment
    ) | (
      { __typename?: 'AssetGroup' }
      & TransferNode_Node_AssetGroup_Fragment
    ) | (
      { __typename?: 'AssetStatic' }
      & TransferNode_Node_AssetStatic_Fragment
    ) | (
      { __typename?: 'AssetV2' }
      & TransferNode_Node_AssetV2_Fragment
    ) | (
      { __typename?: 'AssetValuationV2' }
      & TransferNode_Node_AssetValuationV2_Fragment
    ) | (
      { __typename?: 'AssetValueV2' }
      & TransferNode_Node_AssetValueV2_Fragment
    ) | (
      { __typename?: 'AsyncJob' }
      & TransferNode_Node_AsyncJob_Fragment
    ) | (
      { __typename?: 'BalanceSheetBundleConfiguration' }
      & TransferNode_Node_BalanceSheetBundleConfiguration_Fragment
    ) | (
      { __typename?: 'BalanceSheetCategory' }
      & TransferNode_Node_BalanceSheetCategory_Fragment
    ) | (
      { __typename?: 'BalanceSheetViewConfiguration' }
      & TransferNode_Node_BalanceSheetViewConfiguration_Fragment
    ) | (
      { __typename?: 'BeneficiariesBundleConfiguration' }
      & TransferNode_Node_BeneficiariesBundleConfiguration_Fragment
    ) | (
      { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
      & TransferNode_Node_BeneficiariesTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'Beneficiary' }
      & TransferNode_Node_Beneficiary_Fragment
    ) | (
      { __typename?: 'BeneficiaryAccessParameter' }
      & TransferNode_Node_BeneficiaryAccessParameter_Fragment
    ) | (
      { __typename?: 'BeneficiaryDesignationGroup' }
      & TransferNode_Node_BeneficiaryDesignationGroup_Fragment
    ) | (
      { __typename?: 'BeneficiaryDistribution' }
      & TransferNode_Node_BeneficiaryDistribution_Fragment
    ) | (
      { __typename?: 'BeneficiaryDistributionParameter' }
      & TransferNode_Node_BeneficiaryDistributionParameter_Fragment
    ) | (
      { __typename?: 'BeneficiaryPage' }
      & TransferNode_Node_BeneficiaryPage_Fragment
    ) | (
      { __typename?: 'BeneficiaryPowerOfAppointment' }
      & TransferNode_Node_BeneficiaryPowerOfAppointment_Fragment
    ) | (
      { __typename?: 'CCorpBusinessEntity' }
      & TransferNode_Node_CCorpBusinessEntity_Fragment
    ) | (
      { __typename?: 'CLTProposal' }
      & TransferNode_Node_CltProposal_Fragment
    ) | (
      { __typename?: 'CLTTrust' }
      & TransferNode_Node_CltTrust_Fragment
    ) | (
      { __typename?: 'CRTProposal' }
      & TransferNode_Node_CrtProposal_Fragment
    ) | (
      { __typename?: 'CRTTrust' }
      & TransferNode_Node_CrtTrust_Fragment
    ) | (
      { __typename?: 'Capability' }
      & TransferNode_Node_Capability_Fragment
    ) | (
      { __typename?: 'Cashflow' }
      & TransferNode_Node_Cashflow_Fragment
    ) | (
      { __typename?: 'ClientOrganization' }
      & TransferNode_Node_ClientOrganization_Fragment
    ) | (
      { __typename?: 'ClientPresentationV2' }
      & TransferNode_Node_ClientPresentationV2_Fragment
    ) | (
      { __typename?: 'ClientProfile' }
      & TransferNode_Node_ClientProfile_Fragment
    ) | (
      { __typename?: 'ClientProfileRelationship' }
      & TransferNode_Node_ClientProfileRelationship_Fragment
    ) | (
      { __typename?: 'Collaborator' }
      & TransferNode_Node_Collaborator_Fragment
    ) | (
      { __typename?: 'ComparedWaterfall' }
      & TransferNode_Node_ComparedWaterfall_Fragment
    ) | (
      { __typename?: 'CompletedEstateInsightsPage' }
      & TransferNode_Node_CompletedEstateInsightsPage_Fragment
    ) | (
      { __typename?: 'ControllingParty' }
      & TransferNode_Node_ControllingParty_Fragment
    ) | (
      { __typename?: 'Conversation' }
      & TransferNode_Node_Conversation_Fragment
    ) | (
      { __typename?: 'CoverPageConfiguration' }
      & TransferNode_Node_CoverPageConfiguration_Fragment
    ) | (
      { __typename?: 'CustodialPersonalAccount' }
      & TransferNode_Node_CustodialPersonalAccount_Fragment
    ) | (
      { __typename?: 'DSUEPortability' }
      & TransferNode_Node_DsuePortability_Fragment
    ) | (
      { __typename?: 'DiagramArtifact' }
      & TransferNode_Node_DiagramArtifact_Fragment
    ) | (
      { __typename?: 'DiagramArtifactPrompt' }
      & TransferNode_Node_DiagramArtifactPrompt_Fragment
    ) | (
      { __typename?: 'DispositionScenario' }
      & TransferNode_Node_DispositionScenario_Fragment
    ) | (
      { __typename?: 'DispositiveProvision' }
      & TransferNode_Node_DispositiveProvision_Fragment
    ) | (
      { __typename?: 'DispositiveProvisionTemplate' }
      & TransferNode_Node_DispositiveProvisionTemplate_Fragment
    ) | (
      { __typename?: 'DividerBundleConfiguration' }
      & TransferNode_Node_DividerBundleConfiguration_Fragment
    ) | (
      { __typename?: 'DividerTemplateBundleConfiguration' }
      & TransferNode_Node_DividerTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'Document' }
      & TransferNode_Node_Document_Fragment
    ) | (
      { __typename?: 'DocumentQuestion' }
      & TransferNode_Node_DocumentQuestion_Fragment
    ) | (
      { __typename?: 'DocumentQuestionAnswers' }
      & TransferNode_Node_DocumentQuestionAnswers_Fragment
    ) | (
      { __typename?: 'DocumentSummary' }
      & TransferNode_Node_DocumentSummary_Fragment
    ) | (
      { __typename?: 'DocumentSummaryPage' }
      & TransferNode_Node_DocumentSummaryPage_Fragment
    ) | (
      { __typename?: 'DocumentSummaryPrompt' }
      & TransferNode_Node_DocumentSummaryPrompt_Fragment
    ) | (
      { __typename?: 'DocumentSummaryPromptTestRun' }
      & TransferNode_Node_DocumentSummaryPromptTestRun_Fragment
    ) | (
      { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
      & TransferNode_Node_DocumentSummaryTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'DonorAdvisedFund' }
      & TransferNode_Node_DonorAdvisedFund_Fragment
    ) | (
      { __typename?: 'Employee' }
      & TransferNode_Node_Employee_Fragment
    ) | (
      { __typename?: 'EntitiesOverviewBundleConfiguration' }
      & TransferNode_Node_EntitiesOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
      & TransferNode_Node_EntitiesOverviewBundleConfigurationEntity_Fragment
    ) | (
      { __typename?: 'Entity' }
      & TransferNode_Node_Entity_Fragment
    ) | (
      { __typename?: 'EntityDiagram' }
      & TransferNode_Node_EntityDiagram_Fragment
    ) | (
      { __typename?: 'EntityDocumentRelationship' }
      & TransferNode_Node_EntityDocumentRelationship_Fragment
    ) | (
      { __typename?: 'EntityGraphView' }
      & TransferNode_Node_EntityGraphView_Fragment
    ) | (
      { __typename?: 'EntityGraphViewBundleConfiguration' }
      & TransferNode_Node_EntityGraphViewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntityNotes' }
      & TransferNode_Node_EntityNotes_Fragment
    ) | (
      { __typename?: 'EntityProposal' }
      & TransferNode_Node_EntityProposal_Fragment
    ) | (
      { __typename?: 'EntitySummaryBundleConfiguration' }
      & TransferNode_Node_EntitySummaryBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
      & TransferNode_Node_EntitySummaryTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EntityTask' }
      & TransferNode_Node_EntityTask_Fragment
    ) | (
      { __typename?: 'EntityTaxInfo' }
      & TransferNode_Node_EntityTaxInfo_Fragment
    ) | (
      { __typename?: 'EstateInsight' }
      & TransferNode_Node_EstateInsight_Fragment
    ) | (
      { __typename?: 'EstateInsightReference' }
      & TransferNode_Node_EstateInsightReference_Fragment
    ) | (
      { __typename?: 'EstateInsightsBundleConfiguration' }
      & TransferNode_Node_EstateInsightsBundleConfiguration_Fragment
    ) | (
      { __typename?: 'EstateTaxScenario' }
      & TransferNode_Node_EstateTaxScenario_Fragment
    ) | (
      { __typename?: 'EstateWaterfall' }
      & TransferNode_Node_EstateWaterfall_Fragment
    ) | (
      { __typename?: 'EstateWaterfallHypotheticalStateChange' }
      & TransferNode_Node_EstateWaterfallHypotheticalStateChange_Fragment
    ) | (
      { __typename?: 'EstateWaterfallHypotheticalTransfer' }
      & TransferNode_Node_EstateWaterfallHypotheticalTransfer_Fragment
    ) | (
      { __typename?: 'EstateWaterfallMessageContext' }
      & TransferNode_Node_EstateWaterfallMessageContext_Fragment
    ) | (
      { __typename?: 'EstateWaterfallVisualizationConfig' }
      & TransferNode_Node_EstateWaterfallVisualizationConfig_Fragment
    ) | (
      { __typename?: 'EstateWaterfallVisualizationFilter' }
      & TransferNode_Node_EstateWaterfallVisualizationFilter_Fragment
    ) | (
      { __typename?: 'FamilyTreeBundleConfiguration' }
      & TransferNode_Node_FamilyTreeBundleConfiguration_Fragment
    ) | (
      { __typename?: 'FamilyTreeConfiguration' }
      & TransferNode_Node_FamilyTreeConfiguration_Fragment
    ) | (
      { __typename?: 'FeatureFlag' }
      & TransferNode_Node_FeatureFlag_Fragment
    ) | (
      { __typename?: 'FeatureFlagQueryRule' }
      & TransferNode_Node_FeatureFlagQueryRule_Fragment
    ) | (
      { __typename?: 'File' }
      & TransferNode_Node_File_Fragment
    ) | (
      { __typename?: 'FilePage' }
      & TransferNode_Node_FilePage_Fragment
    ) | (
      { __typename?: 'FileParagraph' }
      & TransferNode_Node_FileParagraph_Fragment
    ) | (
      { __typename?: 'Form' }
      & TransferNode_Node_Form_Fragment
    ) | (
      { __typename?: 'FormVersion' }
      & TransferNode_Node_FormVersion_Fragment
    ) | (
      { __typename?: 'GPBusinessEntity' }
      & TransferNode_Node_GpBusinessEntity_Fragment
    ) | (
      { __typename?: 'GRATAnnuityV2' }
      & TransferNode_Node_GratAnnuityV2_Fragment
    ) | (
      { __typename?: 'GRATProposalScenario' }
      & TransferNode_Node_GratProposalScenario_Fragment
    ) | (
      { __typename?: 'GRATTrust' }
      & TransferNode_Node_GratTrust_Fragment
    ) | (
      { __typename?: 'GiftingProposal' }
      & TransferNode_Node_GiftingProposal_Fragment
    ) | (
      { __typename?: 'GiftingProposalCashFlow' }
      & TransferNode_Node_GiftingProposalCashFlow_Fragment
    ) | (
      { __typename?: 'GiftingProposalGift' }
      & TransferNode_Node_GiftingProposalGift_Fragment
    ) | (
      { __typename?: 'GiftingProposalGiftSender' }
      & TransferNode_Node_GiftingProposalGiftSender_Fragment
    ) | (
      { __typename?: 'GiftingProposalPortfolio' }
      & TransferNode_Node_GiftingProposalPortfolio_Fragment
    ) | (
      { __typename?: 'GiftingProposalScenario' }
      & TransferNode_Node_GiftingProposalScenario_Fragment
    ) | (
      { __typename?: 'GraphVisualizationGroup' }
      & TransferNode_Node_GraphVisualizationGroup_Fragment
    ) | (
      { __typename?: 'GrowthProfile' }
      & TransferNode_Node_GrowthProfile_Fragment
    ) | (
      { __typename?: 'GrowthProfileOverride' }
      & TransferNode_Node_GrowthProfileOverride_Fragment
    ) | (
      { __typename?: 'Household' }
      & TransferNode_Node_Household_Fragment
    ) | (
      { __typename?: 'HypotheticalCLT' }
      & TransferNode_Node_HypotheticalClt_Fragment
    ) | (
      { __typename?: 'HypotheticalCRT' }
      & TransferNode_Node_HypotheticalCrt_Fragment
    ) | (
      { __typename?: 'HypotheticalGRAT' }
      & TransferNode_Node_HypotheticalGrat_Fragment
    ) | (
      { __typename?: 'HypotheticalInsurance' }
      & TransferNode_Node_HypotheticalInsurance_Fragment
    ) | (
      { __typename?: 'HypotheticalSaleLoan' }
      & TransferNode_Node_HypotheticalSaleLoan_Fragment
    ) | (
      { __typename?: 'HypotheticalTransferAsset' }
      & TransferNode_Node_HypotheticalTransferAsset_Fragment
    ) | (
      { __typename?: 'HypotheticalTransferFundingSource' }
      & TransferNode_Node_HypotheticalTransferFundingSource_Fragment
    ) | (
      { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
      & TransferNode_Node_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
    ) | (
      { __typename?: 'ILITCrummeyLetter' }
      & TransferNode_Node_IlitCrummeyLetter_Fragment
    ) | (
      { __typename?: 'ILITTrust' }
      & TransferNode_Node_IlitTrust_Fragment
    ) | (
      { __typename?: 'Image' }
      & TransferNode_Node_Image_Fragment
    ) | (
      { __typename?: 'IncomeTaxPaymentConfig' }
      & TransferNode_Node_IncomeTaxPaymentConfig_Fragment
    ) | (
      { __typename?: 'IndividualPersonalAccount' }
      & TransferNode_Node_IndividualPersonalAccount_Fragment
    ) | (
      { __typename?: 'InferredField' }
      & TransferNode_Node_InferredField_Fragment
    ) | (
      { __typename?: 'InferredFieldEvidence' }
      & TransferNode_Node_InferredFieldEvidence_Fragment
    ) | (
      { __typename?: 'InsightsTemplateBundleConfiguration' }
      & TransferNode_Node_InsightsTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'InsurancePersonalAccount' }
      & TransferNode_Node_InsurancePersonalAccount_Fragment
    ) | (
      { __typename?: 'InsurancePolicy' }
      & TransferNode_Node_InsurancePolicy_Fragment
    ) | (
      { __typename?: 'InsurancePremiumPayment' }
      & TransferNode_Node_InsurancePremiumPayment_Fragment
    ) | (
      { __typename?: 'IntegrationAssetClass' }
      & TransferNode_Node_IntegrationAssetClass_Fragment
    ) | (
      { __typename?: 'IntegrationCashflow' }
      & TransferNode_Node_IntegrationCashflow_Fragment
    ) | (
      { __typename?: 'IntegrationClient' }
      & TransferNode_Node_IntegrationClient_Fragment
    ) | (
      { __typename?: 'IntegrationConfiguration' }
      & TransferNode_Node_IntegrationConfiguration_Fragment
    ) | (
      { __typename?: 'IntegrationEntity' }
      & TransferNode_Node_IntegrationEntity_Fragment
    ) | (
      { __typename?: 'IntegrationInsurance' }
      & TransferNode_Node_IntegrationInsurance_Fragment
    ) | (
      { __typename?: 'IntegrationLiability' }
      & TransferNode_Node_IntegrationLiability_Fragment
    ) | (
      { __typename?: 'IntegrationPerson' }
      & TransferNode_Node_IntegrationPerson_Fragment
    ) | (
      { __typename?: 'IrrevocableTrust' }
      & TransferNode_Node_IrrevocableTrust_Fragment
    ) | (
      { __typename?: 'JointPersonalAccount' }
      & TransferNode_Node_JointPersonalAccount_Fragment
    ) | (
      { __typename?: 'KGNode' }
      & TransferNode_Node_KgNode_Fragment
    ) | (
      { __typename?: 'KGRelationship' }
      & TransferNode_Node_KgRelationship_Fragment
    ) | (
      { __typename?: 'KGRoot' }
      & TransferNode_Node_KgRoot_Fragment
    ) | (
      { __typename?: 'KGV2Document' }
      & TransferNode_Node_Kgv2Document_Fragment
    ) | (
      { __typename?: 'KGV2DocumentChange' }
      & TransferNode_Node_Kgv2DocumentChange_Fragment
    ) | (
      { __typename?: 'KGV2DocumentModification' }
      & TransferNode_Node_Kgv2DocumentModification_Fragment
    ) | (
      { __typename?: 'KGV2Graph' }
      & TransferNode_Node_Kgv2Graph_Fragment
    ) | (
      { __typename?: 'KGV2Node' }
      & TransferNode_Node_Kgv2Node_Fragment
    ) | (
      { __typename?: 'KGV2NodeAlias' }
      & TransferNode_Node_Kgv2NodeAlias_Fragment
    ) | (
      { __typename?: 'KGV2NodeEvidence' }
      & TransferNode_Node_Kgv2NodeEvidence_Fragment
    ) | (
      { __typename?: 'KGV2Statement' }
      & TransferNode_Node_Kgv2Statement_Fragment
    ) | (
      { __typename?: 'KGV2StatementEvidence' }
      & TransferNode_Node_Kgv2StatementEvidence_Fragment
    ) | (
      { __typename?: 'KGV2StatementSupersession' }
      & TransferNode_Node_Kgv2StatementSupersession_Fragment
    ) | (
      { __typename?: 'KeyPerson' }
      & TransferNode_Node_KeyPerson_Fragment
    ) | (
      { __typename?: 'KeyPersonRole' }
      & TransferNode_Node_KeyPersonRole_Fragment
    ) | (
      { __typename?: 'LLCBusinessEntity' }
      & TransferNode_Node_LlcBusinessEntity_Fragment
    ) | (
      { __typename?: 'LPBusinessEntity' }
      & TransferNode_Node_LpBusinessEntity_Fragment
    ) | (
      { __typename?: 'LiabilitiesBundleConfiguration' }
      & TransferNode_Node_LiabilitiesBundleConfiguration_Fragment
    ) | (
      { __typename?: 'Liability' }
      & TransferNode_Node_Liability_Fragment
    ) | (
      { __typename?: 'LiabilityPayment' }
      & TransferNode_Node_LiabilityPayment_Fragment
    ) | (
      { __typename?: 'LifeInsuranceBundleConfiguration' }
      & TransferNode_Node_LifeInsuranceBundleConfiguration_Fragment
    ) | (
      { __typename?: 'LifetimeExclusionEvent' }
      & TransferNode_Node_LifetimeExclusionEvent_Fragment
    ) | (
      { __typename?: 'LoggedTransfer' }
      & TransferNode_Node_LoggedTransfer_Fragment
    ) | (
      { __typename?: 'LuminaryOrganization' }
      & TransferNode_Node_LuminaryOrganization_Fragment
    ) | (
      { __typename?: 'LuminaryTenantJIT' }
      & TransferNode_Node_LuminaryTenantJit_Fragment
    ) | (
      { __typename?: 'ManagedSFTPConnection' }
      & TransferNode_Node_ManagedSftpConnection_Fragment
    ) | (
      { __typename?: 'Memo' }
      & TransferNode_Node_Memo_Fragment
    ) | (
      { __typename?: 'MemoPrompt' }
      & TransferNode_Node_MemoPrompt_Fragment
    ) | (
      { __typename?: 'Message' }
      & TransferNode_Node_Message_Fragment
    ) | (
      { __typename?: 'MissingDocumentOverride' }
      & TransferNode_Node_MissingDocumentOverride_Fragment
    ) | (
      { __typename?: 'MissingDocumentsPage' }
      & TransferNode_Node_MissingDocumentsPage_Fragment
    ) | (
      { __typename?: 'ModelMapping' }
      & TransferNode_Node_ModelMapping_Fragment
    ) | (
      { __typename?: 'NotificationApp' }
      & TransferNode_Node_NotificationApp_Fragment
    ) | (
      { __typename?: 'NotificationPreference' }
      & TransferNode_Node_NotificationPreference_Fragment
    ) | (
      { __typename?: 'OpenaiSdkConfig' }
      & TransferNode_Node_OpenaiSdkConfig_Fragment
    ) | (
      { __typename?: 'OrganizationApplicationConfiguration' }
      & TransferNode_Node_OrganizationApplicationConfiguration_Fragment
    ) | (
      { __typename?: 'OrganizationDisclaimerConfiguration' }
      & TransferNode_Node_OrganizationDisclaimerConfiguration_Fragment
    ) | (
      { __typename?: 'OwnershipStake' }
      & TransferNode_Node_OwnershipStake_Fragment
    ) | (
      { __typename?: 'PlatformDocument' }
      & TransferNode_Node_PlatformDocument_Fragment
    ) | (
      { __typename?: 'PlatformFile' }
      & TransferNode_Node_PlatformFile_Fragment
    ) | (
      { __typename?: 'PlatformFilePage' }
      & TransferNode_Node_PlatformFilePage_Fragment
    ) | (
      { __typename?: 'PlatformFileParagraph' }
      & TransferNode_Node_PlatformFileParagraph_Fragment
    ) | (
      { __typename?: 'PresentationApprovalRequest' }
      & TransferNode_Node_PresentationApprovalRequest_Fragment
    ) | (
      { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
      & TransferNode_Node_PresentationAssetDistributionBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationAssetDistributionItemConfiguration' }
      & TransferNode_Node_PresentationAssetDistributionItemConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationAssetDistributionItemDetail' }
      & TransferNode_Node_PresentationAssetDistributionItemDetail_Fragment
    ) | (
      { __typename?: 'PresentationBundle' }
      & TransferNode_Node_PresentationBundle_Fragment
    ) | (
      { __typename?: 'PresentationBundleCoverPage' }
      & TransferNode_Node_PresentationBundleCoverPage_Fragment
    ) | (
      { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
      & TransferNode_Node_PresentationBusinessOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
      & TransferNode_Node_PresentationBusinessOverviewBusinessConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationBusinessOverviewItem' }
      & TransferNode_Node_PresentationBusinessOverviewItem_Fragment
    ) | (
      { __typename?: 'PresentationCoverPage' }
      & TransferNode_Node_PresentationCoverPage_Fragment
    ) | (
      { __typename?: 'PresentationCoverSlideConfig' }
      & TransferNode_Node_PresentationCoverSlideConfig_Fragment
    ) | (
      { __typename?: 'PresentationCustomPage' }
      & TransferNode_Node_PresentationCustomPage_Fragment
    ) | (
      { __typename?: 'PresentationCustomPageBundleConfiguration' }
      & TransferNode_Node_PresentationCustomPageBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationDiagramPage' }
      & TransferNode_Node_PresentationDiagramPage_Fragment
    ) | (
      { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
      & TransferNode_Node_PresentationDocumentsReviewedBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationDocumentsReviewedDocument' }
      & TransferNode_Node_PresentationDocumentsReviewedDocument_Fragment
    ) | (
      { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
      & TransferNode_Node_PresentationFamilyOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
      & TransferNode_Node_PresentationFamilyOverviewMemberConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
      & TransferNode_Node_PresentationHealthcareDirectiveBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
      & TransferNode_Node_PresentationHealthcareDirectiveClientConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationHealthcareDirectiveItem' }
      & TransferNode_Node_PresentationHealthcareDirectiveItem_Fragment
    ) | (
      { __typename?: 'PresentationItemCitation' }
      & TransferNode_Node_PresentationItemCitation_Fragment
    ) | (
      { __typename?: 'PresentationPage' }
      & TransferNode_Node_PresentationPage_Fragment
    ) | (
      { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
      & TransferNode_Node_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationPlanningOpportunitiesItem' }
      & TransferNode_Node_PresentationPlanningOpportunitiesItem_Fragment
    ) | (
      { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
      & TransferNode_Node_PresentationPowerOfAttorneyBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
      & TransferNode_Node_PresentationPowerOfAttorneyClientConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationPowerOfAttorneyItem' }
      & TransferNode_Node_PresentationPowerOfAttorneyItem_Fragment
    ) | (
      { __typename?: 'PresentationTemplate' }
      & TransferNode_Node_PresentationTemplate_Fragment
    ) | (
      { __typename?: 'PresentationTemplateBundle' }
      & TransferNode_Node_PresentationTemplateBundle_Fragment
    ) | (
      { __typename?: 'PresentationTemplateCoverPage' }
      & TransferNode_Node_PresentationTemplateCoverPage_Fragment
    ) | (
      { __typename?: 'PresentationTemplateCustomPage' }
      & TransferNode_Node_PresentationTemplateCustomPage_Fragment
    ) | (
      { __typename?: 'PresentationTemplateDiagramPage' }
      & TransferNode_Node_PresentationTemplateDiagramPage_Fragment
    ) | (
      { __typename?: 'PresentationTemplatePage' }
      & TransferNode_Node_PresentationTemplatePage_Fragment
    ) | (
      { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
      & TransferNode_Node_PresentationTrustOverviewBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationTrustOverviewItem' }
      & TransferNode_Node_PresentationTrustOverviewItem_Fragment
    ) | (
      { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
      & TransferNode_Node_PresentationTrustOverviewTrustConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationWillBundleConfiguration' }
      & TransferNode_Node_PresentationWillBundleConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationWillClientConfiguration' }
      & TransferNode_Node_PresentationWillClientConfiguration_Fragment
    ) | (
      { __typename?: 'PresentationWillItem' }
      & TransferNode_Node_PresentationWillItem_Fragment
    ) | (
      { __typename?: 'Principal' }
      & TransferNode_Node_Principal_Fragment
    ) | (
      { __typename?: 'PrivateFoundation' }
      & TransferNode_Node_PrivateFoundation_Fragment
    ) | (
      { __typename?: 'ProfessionalTeamRole' }
      & TransferNode_Node_ProfessionalTeamRole_Fragment
    ) | (
      { __typename?: 'Proposal' }
      & TransferNode_Node_Proposal_Fragment
    ) | (
      { __typename?: 'ProposalScenario' }
      & TransferNode_Node_ProposalScenario_Fragment
    ) | (
      { __typename?: 'QPRTTrust' }
      & TransferNode_Node_QprtTrust_Fragment
    ) | (
      { __typename?: 'QualifiedTuitionPersonalAccount' }
      & TransferNode_Node_QualifiedTuitionPersonalAccount_Fragment
    ) | (
      { __typename?: 'ReleaseGroup' }
      & TransferNode_Node_ReleaseGroup_Fragment
    ) | (
      { __typename?: 'ReminderEmailNotificationRecord' }
      & TransferNode_Node_ReminderEmailNotificationRecord_Fragment
    ) | (
      { __typename?: 'RetirementPersonalAccount' }
      & TransferNode_Node_RetirementPersonalAccount_Fragment
    ) | (
      { __typename?: 'RevocableTrust' }
      & TransferNode_Node_RevocableTrust_Fragment
    ) | (
      { __typename?: 'Role' }
      & TransferNode_Node_Role_Fragment
    ) | (
      { __typename?: 'SCorpBusinessEntity' }
      & TransferNode_Node_SCorpBusinessEntity_Fragment
    ) | (
      { __typename?: 'SLATTrust' }
      & TransferNode_Node_SlatTrust_Fragment
    ) | (
      { __typename?: 'SSOConnection' }
      & TransferNode_Node_SsoConnection_Fragment
    ) | (
      { __typename?: 'SalesforceExportAttempt' }
      & TransferNode_Node_SalesforceExportAttempt_Fragment
    ) | (
      { __typename?: 'ScheduledDistribution' }
      & TransferNode_Node_ScheduledDistribution_Fragment
    ) | (
      { __typename?: 'SoleProprietorshipBusinessEntity' }
      & TransferNode_Node_SoleProprietorshipBusinessEntity_Fragment
    ) | (
      { __typename?: 'SubBrand' }
      & TransferNode_Node_SubBrand_Fragment
    ) | (
      { __typename?: 'SubBrandDisclaimerConfiguration' }
      & TransferNode_Node_SubBrandDisclaimerConfiguration_Fragment
    ) | (
      { __typename?: 'Submission' }
      & TransferNode_Node_Submission_Fragment
    ) | (
      { __typename?: 'TaxDragConfig' }
      & TransferNode_Node_TaxDragConfig_Fragment
    ) | (
      { __typename?: 'TaxDragOverride' }
      & TransferNode_Node_TaxDragOverride_Fragment
    ) | (
      { __typename?: 'Team' }
      & TransferNode_Node_Team_Fragment
    ) | (
      { __typename?: 'Tenant' }
      & TransferNode_Node_Tenant_Fragment
    ) | (
      { __typename?: 'TenantApplicationConfiguration' }
      & TransferNode_Node_TenantApplicationConfiguration_Fragment
    ) | (
      { __typename?: 'TenantBranding' }
      & TransferNode_Node_TenantBranding_Fragment
    ) | (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & TransferNode_Node_TenantDisclaimerConfiguration_Fragment
    ) | (
      { __typename?: 'TenantDocument' }
      & TransferNode_Node_TenantDocument_Fragment
    ) | (
      { __typename?: 'TenantReminderEmailsConfiguration' }
      & TransferNode_Node_TenantReminderEmailsConfiguration_Fragment
    ) | (
      { __typename?: 'TenantSSOConnection' }
      & TransferNode_Node_TenantSsoConnection_Fragment
    ) | (
      { __typename?: 'TenantSecurityConfiguration' }
      & TransferNode_Node_TenantSecurityConfiguration_Fragment
    ) | (
      { __typename?: 'TenantSlideConfig' }
      & TransferNode_Node_TenantSlideConfig_Fragment
    ) | (
      { __typename?: 'TestCMKEncryption' }
      & TransferNode_Node_TestCmkEncryption_Fragment
    ) | (
      { __typename?: 'TestamentaryEntity' }
      & TransferNode_Node_TestamentaryEntity_Fragment
    ) | (
      { __typename?: 'TrustAdvisor' }
      & TransferNode_Node_TrustAdvisor_Fragment
    ) | (
      { __typename?: 'TrustAdvisorRole' }
      & TransferNode_Node_TrustAdvisorRole_Fragment
    ) | (
      { __typename?: 'Trustee' }
      & TransferNode_Node_Trustee_Fragment
    ) | (
      { __typename?: 'TrusteeDuty' }
      & TransferNode_Node_TrusteeDuty_Fragment
    ) | (
      { __typename?: 'User' }
      & TransferNode_Node_User_Fragment
    ) | (
      { __typename?: 'UserFeedback' }
      & TransferNode_Node_UserFeedback_Fragment
    ) | (
      { __typename?: 'UserNotificationConfiguration' }
      & TransferNode_Node_UserNotificationConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallBundleConfiguration' }
      & TransferNode_Node_WaterfallBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallBundleCoverPage' }
      & TransferNode_Node_WaterfallBundleCoverPage_Fragment
    ) | (
      { __typename?: 'WaterfallComparisonBundleConfiguration' }
      & TransferNode_Node_WaterfallComparisonBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
      & TransferNode_Node_WaterfallComparisonTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WaterfallTemplateBundleConfiguration' }
      & TransferNode_Node_WaterfallTemplateBundleConfiguration_Fragment
    ) | (
      { __typename?: 'WorkOSOrganization' }
      & TransferNode_Node_WorkOsOrganization_Fragment
    ) | (
      { __typename?: 'WorkOSOrganizationDomain' }
      & TransferNode_Node_WorkOsOrganizationDomain_Fragment
    ) | (
      { __typename?: 'WorkflowTracker' }
      & TransferNode_Node_WorkflowTracker_Fragment
    ) } | null, associatedObject?: { __typename?: 'AISuggestion', id: string } | { __typename?: 'AISuggestionEvidence', id: string } | { __typename?: 'AccessAgeParameter', id: string } | { __typename?: 'AccessParameter', id: string } | { __typename?: 'Account', id: string } | { __typename?: 'ActiveEstateInsightsPage', id: string } | { __typename?: 'Activity', id: string } | { __typename?: 'Address', id: string } | { __typename?: 'Answer', id: string } | { __typename?: 'AnswerEvidence', id: string } | { __typename?: 'AnswerRevision', id: string } | { __typename?: 'Approval', id: string } | { __typename?: 'AssetClass', id: string } | { __typename?: 'AssetGroup', id: string } | { __typename?: 'AssetStatic', id: string } | { __typename?: 'AssetV2', id: string } | { __typename?: 'AssetValuationV2', id: string } | { __typename?: 'AssetValueV2', id: string } | { __typename?: 'AsyncJob', id: string } | { __typename?: 'BalanceSheetBundleConfiguration', id: string } | { __typename?: 'BalanceSheetCategory', id: string } | { __typename?: 'BalanceSheetViewConfiguration', id: string } | { __typename?: 'BeneficiariesBundleConfiguration', id: string } | { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string } | { __typename?: 'Beneficiary', id: string } | { __typename?: 'BeneficiaryAccessParameter', id: string } | { __typename?: 'BeneficiaryDesignationGroup', id: string } | { __typename?: 'BeneficiaryDistribution', id: string } | { __typename?: 'BeneficiaryDistributionParameter', id: string } | { __typename?: 'BeneficiaryPage', id: string } | { __typename?: 'BeneficiaryPowerOfAppointment', id: string } | { __typename?: 'CCorpBusinessEntity', id: string } | { __typename?: 'CLTProposal', id: string } | { __typename?: 'CLTTrust', id: string } | { __typename?: 'CRTProposal', id: string } | { __typename?: 'CRTTrust', id: string } | { __typename?: 'Capability', id: string } | { __typename?: 'Cashflow', id: string } | { __typename?: 'ClientOrganization', id: string } | { __typename?: 'ClientPresentationV2', id: string } | { __typename?: 'ClientProfile', id: string } | { __typename?: 'ClientProfileRelationship', id: string } | { __typename?: 'Collaborator', id: string } | { __typename?: 'ComparedWaterfall', id: string } | { __typename?: 'CompletedEstateInsightsPage', id: string } | { __typename?: 'ControllingParty', id: string } | { __typename?: 'Conversation', id: string } | { __typename?: 'CoverPageConfiguration', id: string } | { __typename?: 'CustodialPersonalAccount', id: string } | { __typename?: 'DSUEPortability', id: string } | { __typename?: 'DiagramArtifact', id: string } | { __typename?: 'DiagramArtifactPrompt', id: string } | { __typename?: 'DispositionScenario', id: string } | { __typename?: 'DispositiveProvision', id: string } | { __typename?: 'DispositiveProvisionTemplate', id: string } | { __typename?: 'DividerBundleConfiguration', id: string } | { __typename?: 'DividerTemplateBundleConfiguration', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'DocumentQuestion', id: string } | { __typename?: 'DocumentQuestionAnswers', id: string } | { __typename?: 'DocumentSummary', id: string } | { __typename?: 'DocumentSummaryPage', id: string } | { __typename?: 'DocumentSummaryPrompt', id: string } | { __typename?: 'DocumentSummaryPromptTestRun', id: string } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string } | { __typename?: 'DonorAdvisedFund', id: string } | { __typename?: 'Employee', id: string } | { __typename?: 'EntitiesOverviewBundleConfiguration', id: string } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string } | { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | { __typename?: 'EntityDiagram', id: string } | { __typename?: 'EntityDocumentRelationship', id: string } | { __typename?: 'EntityGraphView', id: string } | { __typename?: 'EntityGraphViewBundleConfiguration', id: string } | { __typename?: 'EntityNotes', id: string } | { __typename?: 'EntityProposal', id: string } | { __typename?: 'EntitySummaryBundleConfiguration', id: string } | { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string } | { __typename?: 'EntityTask', id: string } | { __typename?: 'EntityTaxInfo', id: string } | { __typename?: 'EstateInsight', id: string } | { __typename?: 'EstateInsightReference', id: string } | { __typename?: 'EstateInsightsBundleConfiguration', id: string } | { __typename?: 'EstateTaxScenario', id: string } | { __typename?: 'EstateWaterfall', id: string } | { __typename?: 'EstateWaterfallHypotheticalStateChange', id: string } | { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string } | { __typename?: 'EstateWaterfallMessageContext', id: string } | { __typename?: 'EstateWaterfallVisualizationConfig', id: string } | { __typename?: 'EstateWaterfallVisualizationFilter', id: string } | { __typename?: 'FamilyTreeBundleConfiguration', id: string } | { __typename?: 'FamilyTreeConfiguration', id: string } | { __typename?: 'FeatureFlag', id: string } | { __typename?: 'FeatureFlagQueryRule', id: string } | { __typename?: 'File', id: string } | { __typename?: 'FilePage', id: string } | { __typename?: 'FileParagraph', id: string } | { __typename?: 'Form', id: string } | { __typename?: 'FormVersion', id: string } | { __typename?: 'GPBusinessEntity', id: string } | { __typename?: 'GRATAnnuityV2', id: string } | { __typename?: 'GRATProposalScenario', id: string } | { __typename?: 'GRATTrust', id: string } | { __typename?: 'GiftingProposal', id: string } | { __typename?: 'GiftingProposalCashFlow', id: string } | { __typename?: 'GiftingProposalGift', id: string } | { __typename?: 'GiftingProposalGiftSender', id: string } | { __typename?: 'GiftingProposalPortfolio', id: string } | { __typename?: 'GiftingProposalScenario', id: string } | { __typename?: 'GraphVisualizationGroup', id: string } | { __typename?: 'GrowthProfile', id: string } | { __typename?: 'GrowthProfileOverride', id: string } | { __typename?: 'Household', id: string } | { __typename?: 'HypotheticalCLT', id: string } | { __typename?: 'HypotheticalCRT', id: string } | { __typename?: 'HypotheticalGRAT', id: string } | { __typename?: 'HypotheticalInsurance', id: string } | { __typename?: 'HypotheticalSaleLoan', id: string } | { __typename?: 'HypotheticalTransferAsset', id: string } | { __typename?: 'HypotheticalTransferFundingSource', id: string } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string } | { __typename?: 'ILITCrummeyLetter', id: string } | { __typename?: 'ILITTrust', id: string } | { __typename?: 'Image', id: string } | { __typename?: 'IncomeTaxPaymentConfig', id: string } | { __typename?: 'IndividualPersonalAccount', id: string } | { __typename?: 'InferredField', id: string } | { __typename?: 'InferredFieldEvidence', id: string } | { __typename?: 'InsightsTemplateBundleConfiguration', id: string } | { __typename?: 'InsurancePersonalAccount', id: string } | { __typename?: 'InsurancePolicy', id: string } | { __typename?: 'InsurancePremiumPayment', id: string } | { __typename?: 'IntegrationAssetClass', id: string } | { __typename?: 'IntegrationCashflow', id: string } | { __typename?: 'IntegrationClient', id: string } | { __typename?: 'IntegrationConfiguration', id: string } | { __typename?: 'IntegrationEntity', id: string } | { __typename?: 'IntegrationInsurance', id: string } | { __typename?: 'IntegrationLiability', id: string } | { __typename?: 'IntegrationPerson', id: string } | { __typename?: 'IrrevocableTrust', id: string } | { __typename?: 'JointPersonalAccount', id: string } | { __typename?: 'KGNode', id: string } | { __typename?: 'KGRelationship', id: string } | { __typename?: 'KGRoot', id: string } | { __typename?: 'KGV2Document', id: string } | { __typename?: 'KGV2DocumentChange', id: string } | { __typename?: 'KGV2DocumentModification', id: string } | { __typename?: 'KGV2Graph', id: string } | { __typename?: 'KGV2Node', id: string } | { __typename?: 'KGV2NodeAlias', id: string } | { __typename?: 'KGV2NodeEvidence', id: string } | { __typename?: 'KGV2Statement', id: string } | { __typename?: 'KGV2StatementEvidence', id: string } | { __typename?: 'KGV2StatementSupersession', id: string } | { __typename?: 'KeyPerson', id: string } | { __typename?: 'KeyPersonRole', id: string } | { __typename?: 'LLCBusinessEntity', id: string } | { __typename?: 'LPBusinessEntity', id: string } | { __typename?: 'LiabilitiesBundleConfiguration', id: string } | { __typename?: 'Liability', id: string } | { __typename?: 'LiabilityPayment', id: string } | { __typename?: 'LifeInsuranceBundleConfiguration', id: string } | { __typename?: 'LifetimeExclusionEvent', id: string } | { __typename?: 'LoggedTransfer', id: string } | { __typename?: 'LuminaryOrganization', id: string } | { __typename?: 'LuminaryTenantJIT', id: string } | { __typename?: 'ManagedSFTPConnection', id: string } | { __typename?: 'Memo', id: string } | { __typename?: 'MemoPrompt', id: string } | { __typename?: 'Message', id: string } | { __typename?: 'MissingDocumentOverride', id: string } | { __typename?: 'MissingDocumentsPage', id: string } | { __typename?: 'ModelMapping', id: string } | { __typename?: 'NotificationApp', id: string } | { __typename?: 'NotificationPreference', id: string } | { __typename?: 'OpenaiSdkConfig', id: string } | { __typename?: 'OrganizationApplicationConfiguration', id: string } | { __typename?: 'OrganizationDisclaimerConfiguration', id: string } | { __typename?: 'OwnershipStake', id: string } | { __typename?: 'PlatformDocument', id: string } | { __typename?: 'PlatformFile', id: string } | { __typename?: 'PlatformFilePage', id: string } | { __typename?: 'PlatformFileParagraph', id: string } | { __typename?: 'PresentationApprovalRequest', id: string } | { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string } | { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string } | { __typename?: 'PresentationAssetDistributionItemDetail', id: string } | { __typename?: 'PresentationBundle', id: string } | { __typename?: 'PresentationBundleCoverPage', id: string } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string } | { __typename?: 'PresentationBusinessOverviewItem', id: string } | { __typename?: 'PresentationCoverPage', id: string } | { __typename?: 'PresentationCoverSlideConfig', id: string } | { __typename?: 'PresentationCustomPage', id: string } | { __typename?: 'PresentationCustomPageBundleConfiguration', id: string } | { __typename?: 'PresentationDiagramPage', id: string } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string } | { __typename?: 'PresentationDocumentsReviewedDocument', id: string } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string } | { __typename?: 'PresentationHealthcareDirectiveItem', id: string } | { __typename?: 'PresentationItemCitation', id: string } | { __typename?: 'PresentationPage', id: string } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string } | { __typename?: 'PresentationPlanningOpportunitiesItem', id: string } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string } | { __typename?: 'PresentationPowerOfAttorneyItem', id: string } | { __typename?: 'PresentationTemplate', id: string } | { __typename?: 'PresentationTemplateBundle', id: string } | { __typename?: 'PresentationTemplateCoverPage', id: string } | { __typename?: 'PresentationTemplateCustomPage', id: string } | { __typename?: 'PresentationTemplateDiagramPage', id: string } | { __typename?: 'PresentationTemplatePage', id: string } | { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string } | { __typename?: 'PresentationTrustOverviewItem', id: string } | { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string } | { __typename?: 'PresentationWillBundleConfiguration', id: string } | { __typename?: 'PresentationWillClientConfiguration', id: string } | { __typename?: 'PresentationWillItem', id: string } | { __typename?: 'Principal', id: string } | { __typename?: 'PrivateFoundation', id: string } | { __typename?: 'ProfessionalTeamRole', id: string } | { __typename?: 'Proposal', id: string } | { __typename?: 'ProposalScenario', id: string } | { __typename?: 'QPRTTrust', id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string } | { __typename?: 'ReleaseGroup', id: string } | { __typename?: 'ReminderEmailNotificationRecord', id: string } | { __typename?: 'RetirementPersonalAccount', id: string } | { __typename?: 'RevocableTrust', id: string } | { __typename?: 'Role', id: string } | { __typename?: 'SCorpBusinessEntity', id: string } | { __typename?: 'SLATTrust', id: string } | { __typename?: 'SSOConnection', id: string } | { __typename?: 'SalesforceExportAttempt', id: string } | { __typename?: 'ScheduledDistribution', id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } | { __typename?: 'SubBrand', id: string } | { __typename?: 'SubBrandDisclaimerConfiguration', id: string } | { __typename?: 'Submission', id: string } | { __typename?: 'TaxDragConfig', id: string } | { __typename?: 'TaxDragOverride', id: string } | { __typename?: 'Team', id: string } | { __typename?: 'Tenant', id: string } | { __typename?: 'TenantApplicationConfiguration', id: string } | { __typename?: 'TenantBranding', id: string } | { __typename?: 'TenantDisclaimerConfiguration', id: string } | { __typename?: 'TenantDocument', id: string } | { __typename?: 'TenantReminderEmailsConfiguration', id: string } | { __typename?: 'TenantSSOConnection', id: string } | { __typename?: 'TenantSecurityConfiguration', id: string } | { __typename?: 'TenantSlideConfig', id: string } | { __typename?: 'TestCMKEncryption', id: string } | { __typename?: 'TestamentaryEntity', id: string } | { __typename?: 'TrustAdvisor', id: string } | { __typename?: 'TrustAdvisorRole', id: string } | { __typename?: 'Trustee', id: string } | { __typename?: 'TrusteeDuty', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserFeedback', id: string } | { __typename?: 'UserNotificationConfiguration', id: string } | { __typename?: 'WaterfallBundleConfiguration', id: string } | { __typename?: 'WaterfallBundleCoverPage', id: string } | { __typename?: 'WaterfallComparisonBundleConfiguration', id: string } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string } | { __typename?: 'WaterfallTemplateBundleConfiguration', id: string } | { __typename?: 'WorkOSOrganization', id: string } | { __typename?: 'WorkOSOrganizationDomain', id: string } | { __typename?: 'WorkflowTracker', id: string } | null };

export type GetHypotheticalTransfers_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, outboundTransfers?: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & GetHypotheticalTransfers_HypotheticalTransferFragment
      ) | null } | null> | null }, inboundTransfers?: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & GetHypotheticalTransfers_HypotheticalTransferFragment
      ) | null } | null> | null }, outboundHypotheticalSaleLoans?: { __typename?: 'HypotheticalSaleLoanConnection', edges?: Array<{ __typename?: 'HypotheticalSaleLoanEdge', node?: (
        { __typename?: 'HypotheticalSaleLoan' }
        & GetHypotheticalTransfers_HypotheticalSaleLoanFragment
      ) | null } | null> | null }, inboundHypotheticalSaleLoans?: { __typename?: 'HypotheticalSaleLoanConnection', edges?: Array<{ __typename?: 'HypotheticalSaleLoanEdge', node?: (
        { __typename?: 'HypotheticalSaleLoan' }
        & GetHypotheticalTransfers_HypotheticalSaleLoanFragment
      ) | null } | null> | null }, outboundHypotheticalGrats?: { __typename?: 'HypotheticalGRATConnection', edges?: Array<{ __typename?: 'HypotheticalGRATEdge', node?: (
        { __typename?: 'HypotheticalGRAT' }
        & GetHypotheticalTransfers_HypotheticalGratFragment
      ) | null } | null> | null }, inboundHypotheticalGrats?: { __typename?: 'HypotheticalGRATConnection', edges?: Array<{ __typename?: 'HypotheticalGRATEdge', node?: (
        { __typename?: 'HypotheticalGRAT' }
        & GetHypotheticalTransfers_HypotheticalGratFragment
      ) | null } | null> | null }, outboundHypotheticalCrts?: { __typename?: 'HypotheticalCRTConnection', edges?: Array<{ __typename?: 'HypotheticalCRTEdge', node?: (
        { __typename?: 'HypotheticalCRT' }
        & GetHypotheticalTransfers_HypotheticalCrtFragment
      ) | null } | null> | null }, inboundHypotheticalCrts?: { __typename?: 'HypotheticalCRTConnection', edges?: Array<{ __typename?: 'HypotheticalCRTEdge', node?: (
        { __typename?: 'HypotheticalCRT' }
        & GetHypotheticalTransfers_HypotheticalCrtFragment
      ) | null } | null> | null }, outboundHypotheticalClts?: { __typename?: 'HypotheticalCLTConnection', edges?: Array<{ __typename?: 'HypotheticalCLTEdge', node?: (
        { __typename?: 'HypotheticalCLT' }
        & GetHypotheticalTransfers_HypotheticalCltFragment
      ) | null } | null> | null }, inboundHypotheticalClts?: { __typename?: 'HypotheticalCLTConnection', edges?: Array<{ __typename?: 'HypotheticalCLTEdge', node?: (
        { __typename?: 'HypotheticalCLT' }
        & GetHypotheticalTransfers_HypotheticalCltFragment
      ) | null } | null> | null }, outboundHypotheticalInsurance?: { __typename?: 'HypotheticalInsuranceConnection', edges?: Array<{ __typename?: 'HypotheticalInsuranceEdge', node?: (
        { __typename?: 'HypotheticalInsurance' }
        & GetHypotheticalTransfers_HypotheticalInsuranceFragment
      ) | null } | null> | null }, inboundHypotheticalInsurance?: { __typename?: 'HypotheticalInsuranceConnection', edges?: Array<{ __typename?: 'HypotheticalInsuranceEdge', node?: (
        { __typename?: 'HypotheticalInsurance' }
        & GetHypotheticalTransfers_HypotheticalInsuranceFragment
      ) | null } | null> | null }, visualizationWithProjections: { __typename?: 'EstateWaterfallViz', _cacheKey: string, loans: Array<(
      { __typename?: 'EstateWaterfallLoan' }
      & GetHypotheticalTransfers_EstateWaterfallLoanFragment
    )>, nodes: Array<(
      { __typename?: 'EstateWaterfallVizNode' }
      & GetHypotheticalTransfers_EstateWaterfallVizNodeFragment
    )>, edges: Array<(
      { __typename?: 'EstateWaterfallVizEdge' }
      & GetHypotheticalTransfers_EstateWaterfallVizEdgeFragment
    )>, transferLog: Array<(
      { __typename?: 'EstateWaterfallTransfer' }
      & GetHypotheticalTransfers_EstateWaterfallTransferFragment
    )> } };

export type GetHypotheticalTransfersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EstateWaterfallWhereInput>;
  outboundHypotheticalTransfersWhere?: Types.InputMaybe<Types.EstateWaterfallHypotheticalTransferWhereInput>;
  inboundHypotheticalTransfersWhere?: Types.InputMaybe<Types.EstateWaterfallHypotheticalTransferWhereInput>;
  skipOutboundHypotheticalTransfers: Types.Scalars['Boolean']['input'];
  skipInboundHypotheticalTransfers: Types.Scalars['Boolean']['input'];
  outboundHypotheticalSaleLoansWhere?: Types.InputMaybe<Types.HypotheticalSaleLoanWhereInput>;
  inboundHypotheticalSaleLoansWhere?: Types.InputMaybe<Types.HypotheticalSaleLoanWhereInput>;
  skipOutboundHypotheticalSaleLoans: Types.Scalars['Boolean']['input'];
  skipInboundHypotheticalSaleLoans: Types.Scalars['Boolean']['input'];
  outboundHypotheticalGratsWhere?: Types.InputMaybe<Types.HypotheticalGratWhereInput>;
  inboundHypotheticalGratsWhere?: Types.InputMaybe<Types.HypotheticalGratWhereInput>;
  skipOutboundHypotheticalGrats: Types.Scalars['Boolean']['input'];
  skipInboundHypotheticalGrats: Types.Scalars['Boolean']['input'];
  outboundHypotheticalCrtsWhere?: Types.InputMaybe<Types.HypotheticalCrtWhereInput>;
  inboundHypotheticalCrtsWhere?: Types.InputMaybe<Types.HypotheticalCrtWhereInput>;
  skipOutboundHypotheticalCrts: Types.Scalars['Boolean']['input'];
  skipInboundHypotheticalCrts: Types.Scalars['Boolean']['input'];
  outboundHypotheticalCltsWhere?: Types.InputMaybe<Types.HypotheticalCltWhereInput>;
  inboundHypotheticalCltsWhere?: Types.InputMaybe<Types.HypotheticalCltWhereInput>;
  skipOutboundHypotheticalClts: Types.Scalars['Boolean']['input'];
  skipInboundHypotheticalClts: Types.Scalars['Boolean']['input'];
  outboundHypotheticalInsuranceWhere?: Types.InputMaybe<Types.HypotheticalInsuranceWhereInput>;
  inboundHypotheticalInsuranceWhere?: Types.InputMaybe<Types.HypotheticalInsuranceWhereInput>;
  skipOutboundHypotheticalInsurance: Types.Scalars['Boolean']['input'];
  skipInboundHypotheticalInsurance: Types.Scalars['Boolean']['input'];
}>;


export type GetHypotheticalTransfersQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall', id: string }
        & GetHypotheticalTransfers_EstateWaterfallFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetHypotheticalTransfers: 'GetHypotheticalTransfers' as const
  },
  Fragment: {
    GetHypotheticalTransfers_HypotheticalTransfer: 'GetHypotheticalTransfers_HypotheticalTransfer' as const,
    GetHypotheticalTransfers_HypotheticalSaleLoan: 'GetHypotheticalTransfers_HypotheticalSaleLoan' as const,
    GetHypotheticalTransfers_HypotheticalGrat: 'GetHypotheticalTransfers_HypotheticalGrat' as const,
    GetHypotheticalTransfers_HypotheticalCRT: 'GetHypotheticalTransfers_HypotheticalCRT' as const,
    GetHypotheticalTransfers_HypotheticalCLT: 'GetHypotheticalTransfers_HypotheticalCLT' as const,
    GetHypotheticalTransfers_HypotheticalInsurance: 'GetHypotheticalTransfers_HypotheticalInsurance' as const,
    GetHypotheticalTransfers_EstateWaterfallLoan: 'GetHypotheticalTransfers_EstateWaterfallLoan' as const,
    GetHypotheticalTransfers_EstateWaterfallNodeValueHistory: 'GetHypotheticalTransfers_EstateWaterfallNodeValueHistory' as const,
    GetHypotheticalTransfers_EstateWaterfallVizNode: 'GetHypotheticalTransfers_EstateWaterfallVizNode' as const,
    GetHypotheticalTransfers_EstateWaterfallVizEdge: 'GetHypotheticalTransfers_EstateWaterfallVizEdge' as const,
    TransferNode_Node: 'TransferNode_Node' as const,
    GetHypotheticalTransfers_EstateWaterfallTransfer: 'GetHypotheticalTransfers_EstateWaterfallTransfer' as const,
    GetHypotheticalTransfers_EstateWaterfall: 'GetHypotheticalTransfers_EstateWaterfall' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetHypotheticalTransfers_HypotheticalTransferFragmentDoc = gql`
    fragment GetHypotheticalTransfers_HypotheticalTransfer on EstateWaterfallHypotheticalTransfer {
  id
  sourceKind
  destinationKind
  transferOrder
  transferTaxKind
  transferValue
  taxableValue
  startYear
  endYear
  name
  assetGrowthReturn
  destinationEntity {
    id
    extendedDisplayKind
    subtype {
      id
      displayName
    }
  }
  destinationIndividual {
    id
    displayName
  }
  destinationOrganization {
    id
    name
  }
  sourceEntity {
    id
    ... on Entity {
      ...EntityDetail_Entity
    }
  }
  sourceIndividual {
    id
    ... on ClientProfile {
      ...ClientProfileSummaryPanel_ClientProfile
    }
  }
  sourceOwnedEntity {
    id
    subtype {
      id
      displayName
    }
  }
}
    ${EntityDetail_EntityFragmentDoc}
${ClientProfileSummaryPanel_ClientProfileFragmentDoc}`;
export const GetHypotheticalTransfers_HypotheticalSaleLoanFragmentDoc = gql`
    fragment GetHypotheticalTransfers_HypotheticalSaleLoan on HypotheticalSaleLoan {
  id
  displayName
  startDate
  termLengthYears
  kind
  sourceKind
  sourceEntity {
    ...HypotheticalTransfersSummary_Entity
  }
  sourceIndividual {
    ...HypotheticalTransfersSummary_ClientProfile
  }
  recipientKind
  recipientEntity {
    ...HypotheticalTransfersSummary_Entity
  }
  recipientIndividual {
    ...HypotheticalTransfersSummary_ClientProfile
  }
}
    ${HypotheticalTransfersSummary_EntityFragmentDoc}
${HypotheticalTransfersSummary_ClientProfileFragmentDoc}`;
export const GetHypotheticalTransfers_HypotheticalGratFragmentDoc = gql`
    fragment GetHypotheticalTransfers_HypotheticalGrat on HypotheticalGRAT {
  id
  displayName
  funding {
    id
    kind
    proRataAmount
  }
  simulatedGrat {
    id
    subtype {
      id
      displayName
    }
  }
  sourceEntity {
    ...HypotheticalTransfersSummary_Entity
  }
}
    ${HypotheticalTransfersSummary_EntityFragmentDoc}`;
export const GetHypotheticalTransfers_HypotheticalCrtFragmentDoc = gql`
    fragment GetHypotheticalTransfers_HypotheticalCRT on HypotheticalCRT {
  id
  displayName
  funding {
    id
    kind
    proRataAmount
  }
  simulatedCrt {
    id
    displayName
    crtProposal {
      id
      termKind
    }
  }
  sourceEntity {
    ...HypotheticalTransfersSummary_Entity
  }
}
    ${HypotheticalTransfersSummary_EntityFragmentDoc}`;
export const GetHypotheticalTransfers_HypotheticalCltFragmentDoc = gql`
    fragment GetHypotheticalTransfers_HypotheticalCLT on HypotheticalCLT {
  id
  displayName
  funding {
    id
    kind
    proRataAmount
  }
  simulatedClt {
    id
    displayName
    cltProposal {
      id
      termKind
    }
  }
  sourceEntity {
    ...HypotheticalTransfersSummary_Entity
  }
}
    ${HypotheticalTransfersSummary_EntityFragmentDoc}`;
export const GetHypotheticalTransfers_HypotheticalInsuranceFragmentDoc = gql`
    fragment GetHypotheticalTransfers_HypotheticalInsurance on HypotheticalInsurance {
  id
  displayName
  startYear
  endYear
  transferValue
  sourceKind
  endsOnKind
  sourceIndividual {
    ...HypotheticalTransfersSummary_ClientProfile
  }
  sourceEntity {
    ...HypotheticalTransfersSummary_Entity
  }
  destinationEntity {
    ...HypotheticalTransfersSummary_Entity
  }
}
    ${HypotheticalTransfersSummary_ClientProfileFragmentDoc}
${HypotheticalTransfersSummary_EntityFragmentDoc}`;
export const GetHypotheticalTransfers_EstateWaterfallLoanFragmentDoc = gql`
    fragment GetHypotheticalTransfers_EstateWaterfallLoan on EstateWaterfallLoan {
  id
  pseudoID
  valueHistory {
    year
    beginningOfYearValue
    interestPaid
    principalPaid
  }
}
    `;
export const GetHypotheticalTransfers_EstateWaterfallNodeValueHistoryFragmentDoc = gql`
    fragment GetHypotheticalTransfers_EstateWaterfallNodeValueHistory on EstateWaterfallNodeValueHistory {
  year
  endOfYearValue
  beginningOfYearValue
}
    `;
export const GetHypotheticalTransfers_EstateWaterfallVizNodeFragmentDoc = gql`
    fragment GetHypotheticalTransfers_EstateWaterfallVizNode on EstateWaterfallVizNode {
  _cacheKey
  id
  valueHistory {
    ...GetHypotheticalTransfers_EstateWaterfallNodeValueHistory
  }
}
    ${GetHypotheticalTransfers_EstateWaterfallNodeValueHistoryFragmentDoc}`;
export const GetHypotheticalTransfers_EstateWaterfallVizEdgeFragmentDoc = gql`
    fragment GetHypotheticalTransfers_EstateWaterfallVizEdge on EstateWaterfallVizEdge {
  to {
    _cacheKey
    id
  }
  from {
    _cacheKey
    id
  }
  associatedTransfers {
    transfer {
      id
    }
    value
  }
}
    `;
export const TransferNode_NodeFragmentDoc = gql`
    fragment TransferNode_Node on Node {
  id
  ... on Entity {
    id
    subtype {
      id
      displayName
    }
  }
  ... on ClientProfile {
    id
    displayName
  }
  ... on ClientOrganization {
    id
    name
  }
  ... on Proposal {
    id
    displayName
    crtProposal {
      id
      payoutKind
    }
    cltProposal {
      id
      payoutKind
    }
  }
}
    `;
export const GetHypotheticalTransfers_EstateWaterfallTransferFragmentDoc = gql`
    fragment GetHypotheticalTransfers_EstateWaterfallTransfer on EstateWaterfallTransfer {
  year
  kind
  finalTransferAmount
  source {
    _cacheKey
    id
    node {
      ...TransferNode_Node
    }
  }
  destination {
    _cacheKey
    id
    node {
      ...TransferNode_Node
    }
  }
  associatedObjectID
  associatedObject {
    id
    ... on Entity {
      id
      subtype {
        id
        displayName
      }
    }
  }
}
    ${TransferNode_NodeFragmentDoc}`;
export const GetHypotheticalTransfers_EstateWaterfallFragmentDoc = gql`
    fragment GetHypotheticalTransfers_EstateWaterfall on EstateWaterfall {
  id
  outboundTransfers: hypotheticalTransfers(
    where: $outboundHypotheticalTransfersWhere
  ) @skip(if: $skipOutboundHypotheticalTransfers) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalTransfer
      }
    }
  }
  inboundTransfers: hypotheticalTransfers(
    where: $inboundHypotheticalTransfersWhere
  ) @skip(if: $skipInboundHypotheticalTransfers) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalTransfer
      }
    }
  }
  outboundHypotheticalSaleLoans: hypotheticalSaleLoans(
    where: $outboundHypotheticalSaleLoansWhere
  ) @skip(if: $skipOutboundHypotheticalSaleLoans) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalSaleLoan
      }
    }
  }
  inboundHypotheticalSaleLoans: hypotheticalSaleLoans(
    where: $inboundHypotheticalSaleLoansWhere
  ) @skip(if: $skipInboundHypotheticalSaleLoans) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalSaleLoan
      }
    }
  }
  outboundHypotheticalGrats: hypotheticalGrats(
    where: $outboundHypotheticalGratsWhere
  ) @skip(if: $skipOutboundHypotheticalGrats) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalGrat
      }
    }
  }
  inboundHypotheticalGrats: hypotheticalGrats(
    where: $inboundHypotheticalGratsWhere
  ) @skip(if: $skipInboundHypotheticalGrats) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalGrat
      }
    }
  }
  outboundHypotheticalCrts: hypotheticalCrts(
    where: $outboundHypotheticalCrtsWhere
  ) @skip(if: $skipOutboundHypotheticalCrts) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalCRT
      }
    }
  }
  inboundHypotheticalCrts: hypotheticalCrts(where: $inboundHypotheticalCrtsWhere) @skip(if: $skipInboundHypotheticalCrts) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalCRT
      }
    }
  }
  outboundHypotheticalClts: hypotheticalClts(
    where: $outboundHypotheticalCltsWhere
  ) @skip(if: $skipOutboundHypotheticalClts) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalCLT
      }
    }
  }
  inboundHypotheticalClts: hypotheticalClts(where: $inboundHypotheticalCltsWhere) @skip(if: $skipInboundHypotheticalClts) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalCLT
      }
    }
  }
  outboundHypotheticalInsurance: hypotheticalInsurance(
    where: $outboundHypotheticalInsuranceWhere
  ) @skip(if: $skipOutboundHypotheticalInsurance) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalInsurance
      }
    }
  }
  inboundHypotheticalInsurance: hypotheticalInsurance(
    where: $inboundHypotheticalInsuranceWhere
  ) @skip(if: $skipInboundHypotheticalInsurance) {
    edges {
      node {
        ...GetHypotheticalTransfers_HypotheticalInsurance
      }
    }
  }
  visualizationWithProjections {
    _cacheKey
    loans {
      ...GetHypotheticalTransfers_EstateWaterfallLoan
    }
    nodes {
      ...GetHypotheticalTransfers_EstateWaterfallVizNode
    }
    edges {
      ...GetHypotheticalTransfers_EstateWaterfallVizEdge
    }
    transferLog {
      ...GetHypotheticalTransfers_EstateWaterfallTransfer
    }
  }
}
    ${GetHypotheticalTransfers_HypotheticalTransferFragmentDoc}
${GetHypotheticalTransfers_HypotheticalSaleLoanFragmentDoc}
${GetHypotheticalTransfers_HypotheticalGratFragmentDoc}
${GetHypotheticalTransfers_HypotheticalCrtFragmentDoc}
${GetHypotheticalTransfers_HypotheticalCltFragmentDoc}
${GetHypotheticalTransfers_HypotheticalInsuranceFragmentDoc}
${GetHypotheticalTransfers_EstateWaterfallLoanFragmentDoc}
${GetHypotheticalTransfers_EstateWaterfallVizNodeFragmentDoc}
${GetHypotheticalTransfers_EstateWaterfallVizEdgeFragmentDoc}
${GetHypotheticalTransfers_EstateWaterfallTransferFragmentDoc}`;
export const GetHypotheticalTransfersDocument = gql`
    query GetHypotheticalTransfers($where: EstateWaterfallWhereInput, $outboundHypotheticalTransfersWhere: EstateWaterfallHypotheticalTransferWhereInput, $inboundHypotheticalTransfersWhere: EstateWaterfallHypotheticalTransferWhereInput, $skipOutboundHypotheticalTransfers: Boolean!, $skipInboundHypotheticalTransfers: Boolean!, $outboundHypotheticalSaleLoansWhere: HypotheticalSaleLoanWhereInput, $inboundHypotheticalSaleLoansWhere: HypotheticalSaleLoanWhereInput, $skipOutboundHypotheticalSaleLoans: Boolean!, $skipInboundHypotheticalSaleLoans: Boolean!, $outboundHypotheticalGratsWhere: HypotheticalGRATWhereInput, $inboundHypotheticalGratsWhere: HypotheticalGRATWhereInput, $skipOutboundHypotheticalGrats: Boolean!, $skipInboundHypotheticalGrats: Boolean!, $outboundHypotheticalCrtsWhere: HypotheticalCRTWhereInput, $inboundHypotheticalCrtsWhere: HypotheticalCRTWhereInput, $skipOutboundHypotheticalCrts: Boolean!, $skipInboundHypotheticalCrts: Boolean!, $outboundHypotheticalCltsWhere: HypotheticalCLTWhereInput, $inboundHypotheticalCltsWhere: HypotheticalCLTWhereInput, $skipOutboundHypotheticalClts: Boolean!, $skipInboundHypotheticalClts: Boolean!, $outboundHypotheticalInsuranceWhere: HypotheticalInsuranceWhereInput, $inboundHypotheticalInsuranceWhere: HypotheticalInsuranceWhereInput, $skipOutboundHypotheticalInsurance: Boolean!, $skipInboundHypotheticalInsurance: Boolean!) {
  estateWaterfalls(where: $where) {
    edges {
      node {
        id
        ...GetHypotheticalTransfers_EstateWaterfall
      }
    }
  }
}
    ${GetHypotheticalTransfers_EstateWaterfallFragmentDoc}`;

/**
 * __useGetHypotheticalTransfersQuery__
 *
 * To run a query within a React component, call `useGetHypotheticalTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHypotheticalTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHypotheticalTransfersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      outboundHypotheticalTransfersWhere: // value for 'outboundHypotheticalTransfersWhere'
 *      inboundHypotheticalTransfersWhere: // value for 'inboundHypotheticalTransfersWhere'
 *      skipOutboundHypotheticalTransfers: // value for 'skipOutboundHypotheticalTransfers'
 *      skipInboundHypotheticalTransfers: // value for 'skipInboundHypotheticalTransfers'
 *      outboundHypotheticalSaleLoansWhere: // value for 'outboundHypotheticalSaleLoansWhere'
 *      inboundHypotheticalSaleLoansWhere: // value for 'inboundHypotheticalSaleLoansWhere'
 *      skipOutboundHypotheticalSaleLoans: // value for 'skipOutboundHypotheticalSaleLoans'
 *      skipInboundHypotheticalSaleLoans: // value for 'skipInboundHypotheticalSaleLoans'
 *      outboundHypotheticalGratsWhere: // value for 'outboundHypotheticalGratsWhere'
 *      inboundHypotheticalGratsWhere: // value for 'inboundHypotheticalGratsWhere'
 *      skipOutboundHypotheticalGrats: // value for 'skipOutboundHypotheticalGrats'
 *      skipInboundHypotheticalGrats: // value for 'skipInboundHypotheticalGrats'
 *      outboundHypotheticalCrtsWhere: // value for 'outboundHypotheticalCrtsWhere'
 *      inboundHypotheticalCrtsWhere: // value for 'inboundHypotheticalCrtsWhere'
 *      skipOutboundHypotheticalCrts: // value for 'skipOutboundHypotheticalCrts'
 *      skipInboundHypotheticalCrts: // value for 'skipInboundHypotheticalCrts'
 *      outboundHypotheticalCltsWhere: // value for 'outboundHypotheticalCltsWhere'
 *      inboundHypotheticalCltsWhere: // value for 'inboundHypotheticalCltsWhere'
 *      skipOutboundHypotheticalClts: // value for 'skipOutboundHypotheticalClts'
 *      skipInboundHypotheticalClts: // value for 'skipInboundHypotheticalClts'
 *      outboundHypotheticalInsuranceWhere: // value for 'outboundHypotheticalInsuranceWhere'
 *      inboundHypotheticalInsuranceWhere: // value for 'inboundHypotheticalInsuranceWhere'
 *      skipOutboundHypotheticalInsurance: // value for 'skipOutboundHypotheticalInsurance'
 *      skipInboundHypotheticalInsurance: // value for 'skipInboundHypotheticalInsurance'
 *   },
 * });
 */
export function useGetHypotheticalTransfersQuery(baseOptions: Apollo.QueryHookOptions<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>(GetHypotheticalTransfersDocument, withFetchPolicyContext(options));
      }
export function useGetHypotheticalTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>(GetHypotheticalTransfersDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetHypotheticalTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>(GetHypotheticalTransfersDocument, withFetchPolicyContext(options));
        }
export type GetHypotheticalTransfersQueryHookResult = ReturnType<typeof useGetHypotheticalTransfersQuery>;
export type GetHypotheticalTransfersLazyQueryHookResult = ReturnType<typeof useGetHypotheticalTransfersLazyQuery>;
export type GetHypotheticalTransfersSuspenseQueryHookResult = ReturnType<typeof useGetHypotheticalTransfersSuspenseQuery>;
export type GetHypotheticalTransfersQueryResult = Apollo.QueryResult<GetHypotheticalTransfersQuery, GetHypotheticalTransfersQueryVariables>;